"use strict";

class PropertyDocumentsEditorController {

    constructor($scope, $window, $sce, Upload, SSAwsService, SSHttpService, SSUtilService, SSAlertService, SSConfigService, SSAppService, SSUserService, OTPService, $timeout, SSConfirmationService) {
        const self = this;

        self.uploadedImage = null;

        self.$scope = $scope;
        self.$window = $window;
        self.$timeout = $timeout;
        self.sce = $sce;

        self.Upload = Upload;
        self.SSAwsService = SSAwsService;
        self.SSHttpService = SSHttpService;
        self.SSUtilService = SSUtilService;
        self.SSAppService = SSAppService;
        self.SSAlertService = SSAlertService;
        self.SSConfigService = SSConfigService;
        self.SSUserService = SSUserService;
        self.OTPService = OTPService;
        self.SSConfirmationService = SSConfirmationService;

        self.PROPERTY_DOCUMENT_TYPE_FORM = SHOWSUITE.PROPERTY_DOCUMENT_TYPE_FORM;
        self.PROPERTY_DOCUMENT_TYPE_SYSTEM_GENERATED = SHOWSUITE.PROPERTY_DOCUMENT_TYPE_SYSTEM_GENERATED;

        self.PROPERTY_DOCUMENT_KIND_DECLARATION_FORM = SHOWSUITE.PROPERTY_DOCUMENT_KIND_DECLARATION_FORM;
        self.PROPERTY_DOCUMENT_KIND_COVER_LETTER_FORM = SHOWSUITE.PROPERTY_DOCUMENT_KIND_COVER_LETTER_FORM;
        self.PROPERTY_DOCUMENT_KIND_SIDE_LETTER = SHOWSUITE.PROPERTY_DOCUMENT_KIND_SIDE_LETTER;
        self.PROPERTY_DOCUMENT_KIND_PDI_FORM = SHOWSUITE.PROPERTY_DOCUMENT_KIND_PDI_FORM;
        self.PROPERTY_DOCUMENT_KIND_BUYER_PARTICULARS = SHOWSUITE.PROPERTY_DOCUMENT_KIND_BUYER_PARTICULARS;
        self.PROPERTY_DOCUMENT_KIND_OTP = SHOWSUITE.PROPERTY_DOCUMENT_KIND_OTP;
        self.PROPERTY_DOCUMENT_KIND_ANNEXES = SHOWSUITE.PROPERTY_DOCUMENT_KIND_ANNEXES;
        self.PROPERTY_DOCUMENT_KIND_ANNEX_A = SHOWSUITE.PROPERTY_DOCUMENT_KIND_ANNEX_A;
        self.PROPERTY_DOCUMENT_KIND_ANNEX_B3 = SHOWSUITE.PROPERTY_DOCUMENT_KIND_ANNEX_B3;
        self.PROPERTY_DOCUMENT_KIND_ANNEX_C = SHOWSUITE.PROPERTY_DOCUMENT_KIND_ANNEX_C;
        self.PROPERTY_DOCUMENT_KIND_BUYER_CONGRATULATIONS_LETTER = SHOWSUITE.PROPERTY_DOCUMENT_KIND_BUYER_CONGRATULATIONS_LETTER;
        self.PROPERTY_DOCUMENT_KIND_EOI_APPLICATION = SHOWSUITE.PROPERTY_DOCUMENT_KIND_EOI_APPLICATION;
        self.PROPERTY_DOCUMENT_KIND_EOI_BALLOT_TICKETS = SHOWSUITE.PROPERTY_DOCUMENT_KIND_EOI_BALLOT_TICKETS;
        self.PROPERTY_DOCUMENT_KIND_ELITE_MEMBERSHIP_FORM = SHOWSUITE.PROPERTY_DOCUMENT_KIND_ELITE_MEMBERSHIP_FORM;
        self.PROPERTY_DOCUMENT_KIND_EXTERNAL_AGENT = SHOWSUITE.PROPERTY_DOCUMENT_KIND_EXTERNAL_AGENT;
        self.PROPERTY_DOCUMENT_KIND_CDD_FORM_A1 = SHOWSUITE.PROPERTY_DOCUMENT_KIND_CDD_FORM_A1;
        self.PROPERTY_DOCUMENT_KIND_CDD_FORM_A2 = SHOWSUITE.PROPERTY_DOCUMENT_KIND_CDD_FORM_A2;
        self.PROPERTY_DOCUMENT_KIND_CDD_FORM_A3 = SHOWSUITE.PROPERTY_DOCUMENT_KIND_CDD_FORM_A3;
        self.PROPERTY_DOCUMENT_KIND_CDD_FORM_B = SHOWSUITE.PROPERTY_DOCUMENT_KIND_CDD_FORM_B;
        self.PROPERTY_DOCUMENT_KIND_CDD_FORM_C = SHOWSUITE.PROPERTY_DOCUMENT_KIND_CDD_FORM_C;
        self.PROPERTY_DOCUMENT_KIND_CDD_FORM_D = SHOWSUITE.PROPERTY_DOCUMENT_KIND_CDD_FORM_D;
        self.PROPERTY_DOCUMENT_KIND_CDD_FORM_E = SHOWSUITE.PROPERTY_DOCUMENT_KIND_CDD_FORM_E;
        self.PROPERTY_DOCUMENT_KIND_CDD_FORM_F = SHOWSUITE.PROPERTY_DOCUMENT_KIND_CDD_FORM_F;
        self.PROPERTY_DOCUMENT_KIND_CDD_FORM_F_A2 = SHOWSUITE.PROPERTY_DOCUMENT_KIND_CDD_FORM_F_A2;
        self.PROPERTY_DOCUMENT_KIND_CDD_FORM_G = SHOWSUITE.PROPERTY_DOCUMENT_KIND_CDD_FORM_G;
        self.PROPERTY_DOCUMENT_KIND_OTHER = SHOWSUITE.PROPERTY_DOCUMENT_KIND_OTHER;
        self.PROPERTY_DOCUMENT_KIND_TAX_INVOICE = SHOWSUITE.PROPERTY_DOCUMENT_KIND_TAX_INVOICE;
        self.PROPERTY_DOCUMENT_KIND_OFFICIAL_RECEIPT = SHOWSUITE.PROPERTY_DOCUMENT_KIND_OFICIAL_RECEIPT;

        self.ASSET_MODEL_BUYER_DOCUMENT = SHOWSUITE.ASSET_MODEL_BUYER_DOCUMENT;
        self.PROPERTY_DOCUMENT_FORMAT_PDF = SHOWSUITE.PROPERTY_DOCUMENT_FORMAT_PDF;
        self.ASSET_MODEL_PROPERTY_DOCUMENT = SHOWSUITE.ASSET_MODEL_PROPERTY_DOCUMENT;
        self.PROPERTY_DOCUMENT_FORMAT_HTML = SHOWSUITE.PROPERTY_DOCUMENT_FORMAT_HTML;

        self.data = SHOWSUITE.data;
        self.property_id = SHOWSUITE.data.property_id;
        self.document_id = SHOWSUITE.data.document_id;
        self.EDITOR_API_KEY = SHOWSUITE.data.EDITOR_API_KEY;

        self.has_access = false;
        self.IS_FLUTTER_APP = false;

        // WEB-3744/WEB-3976: the Flutter app opens this page in a bare WebView,
        // which has no browser session/localStorage user. It sends its own
        // api_token (and, since WEB-3976, MARKER-ROLE) encoded together into
        // the `q` query param; the controller decodes `q` server-side and
        // hands us the plain values via SHOWSUITE.data, so we never re-parse
        // the URL here.
        //
        // WEB-3591: the controller now puts that token straight into the
        // server-side session and tells us only WHETHER it had one. We can no
        // longer seed a local user from it to get past getProfile()'s "is
        // anyone logged in" guard, so the fetch is forced instead; it
        // authenticates through the same-origin proxy off the session cookie
        // this page's response set.
        if (self.data.has_api_token) { // Authenticated by the app, not by a browser session
            self.IS_FLUTTER_APP = true;
            // self.dispatchEvents("IS_FLUTTER_APP set true");
            // Every outgoing call from this page goes through SSHttpService
            // (directly, or via SSAwsService which delegates to it), so a
            // single default header covers Froala save/load and asset
            // lookups alike. This can't be threaded through as a per-call
            // header instead: SSHttpService.sendRequest() never forwards its
            // `headers` param on POST/PUT, which would silently drop it on
            // exactly the save action.
            //
            // Header name is 'Marker-Role' (not the app's internal
            // 'MARKER-ROLE' convention) because the API server's CORS
            // preflight only allowed this exact casing. The proxy forwards it
            // under the same name, so it is kept as-is.
            if (self.data.marker_role) {
                self.SSHttpService.$http.defaults.headers.common['Marker-Role'] = self.data.marker_role;
            }
            self.SSUserService.getProfile(function () {
                // self.dispatchEvents('user profile getted', self.SSUserService.getUser());
                if (self.SSUserService.isDeveloper()) {
                    self.SSAppService.getServerConfig();
                    self.init();
                    self.has_access = true;
                    self.dispatchEvents('user is developer');
                }
            }, true); // force: no cached user exists in this WebView
        } else if (self.SSUserService.isDeveloper()) {
            // self.dispatchEvents('user found and is developer');
            self.init();
            self.has_access = true;
        }
        // else {
        //     self.dispatchEvents('user found but not developer'+ self.SSUserService.getUser().id);
        //     if(self.SSUserService.getUser()) {
        //         try{
        //             self.dispatchEvents('user details'+ JSON.stringify(self.SSUserService.getUser()));
        //         } catch (e) {
        //             self.dispatchEvents('error parsing user details'+ e);
        //         }
        //
        //     }
        // }
    }

    init() {
        const self = this;

        self.editor = null;
        self.documents = [];
        self.file_uri = '';

        self.editor_pages = [];
        self.editor_current_page = 1;

        self.ADVANCED_OPTIONS = [];
        self.PROPERTY_OPTIONS = [];
        self.UNIT_OPTIONS = [];

        // Separate 'BUYER_OPTIONS' to multiple dropdowns for buyer 1, 2, 3 and 4
        self.BUYER_OPTIONS = [];
        self.BUYER1_OPTIONS = [];
        self.BUYER2_OPTIONS = [];
        self.BUYER3_OPTIONS = [];
        self.BUYER4_OPTIONS = [];

        self.NON_BUYER_PAYEE1_OPTIONS = [];
        self.NON_BUYER_PAYEE2_OPTIONS = [];
        self.NON_BUYER_PAYEE3_OPTIONS = [];
        self.NON_BUYER_PAYEE4_OPTIONS = [];
        self.NON_BUYER_PAYEE5_OPTIONS = [];
        self.NON_BUYER_PAYEE6_OPTIONS = [];

        self.WITNESS1_OPTIONS = [];
        self.WITNESS2_OPTIONS = [];
        self.WITNESS3_OPTIONS = [];
        self.WITNESS4_OPTIONS = [];

        self.AUTHORISED_OFFICER_OPTIONS = [];

        self.SIGNATURE_OPTIONS = [];
        self.QUESTIONNAIRE_OPTIONS = [];
        self.PAYMENT_OPTIONS = [];
        self.LAWYER_OPTIONS = [];
        self.BROKER_OPTIONS = [];
        self.BROKER_OPTIONS_1 = [];
        self.REISSUE_OPTIONS = [];
        self.EOI_OPTIONS = [];
        self.CURRENT_USER_OPTIONS = [];

        self.BENEFICIARY1_OPTIONS = [];
        self.BENEFICIARY2_OPTIONS = [];

        self.getProperty();

        self.buyersNo = ['', '1', '2', '3', '4'];
        self.beneficiaryNo = ['1', '2'];

        self.setAdvancedOptions();
        self.setPropertyOptions();
        self.setUnitOptions();
        // Call 'setBuyerOptions' in 'getPropertyQuestions' to render 'Questions' in dropdown 
        // self.setBuyerOptions();
        self.setSignatureOptions();
        self.setPaymentOptions();
        self.setLawyerOptions();
        self.setBrokerOptions();
        self.setBrokerOptions1();

        // Re-issue Options WEB-1425
        self.setReissueOptions();
        self.setEOIOptions();
        self.setCurrentUserOptions();
        self.setBeneficiaryOptions();
    }

    // 'UniqueValue' method for 'grouped' and 'ungrouped' checkboxes and radio buttons
    getUniqueValue(){
        const self = this;

        return Math.random().toString(36).substring(2, 15);
    }

    setAdvancedOptions() {
        const self = this;

        self.ADVANCED_OPTIONS.push({
            id: 'advance_option_1',
            title: 'Date Default (YYYY-MM-DD hh:mm:ss)',
            type: 'date',
            label: '[Date]',
            code: "{{$date_default}}"
        });
        self.ADVANCED_OPTIONS.push({
            id: 'advance_option_2',
            title: 'Date Format1 (F YYYY)',
            type: 'date',
            label: '[Date]',
            code: "{{$date_format1}}"
        });
        self.ADVANCED_OPTIONS.push({
            id: 'advance_option_3',
            title: 'Date Format2 (DD MM YYYY)',
            type: 'date',
            label: '[Date]',
            code: "{{$date_format2}}"
        });
        self.ADVANCED_OPTIONS.push({
            id: 'advance_option_4',
            title: 'Date Format3 (DD/MM/YYYY)',
            type: 'date',
            label: '[Date]',
            code: "{{$date_format3}}"
        });
        self.ADVANCED_OPTIONS.push({
            id: 'advance_option_5',
            title: 'Date Year (YYYY)',
            type: 'date',
            label: '[Date Year]',
            code: "{{$date_format_year}}"
        });
        self.ADVANCED_OPTIONS.push({
            id: 'advance_option_6',
            title: 'Date Month (MMMM)',
            type: 'date',
            label: '[Date Month]',
            code: "{{$date_format_month}}"
        });
        self.ADVANCED_OPTIONS.push({
            id: 'advance_option_7',
            title: 'Date Day (DD)',
            type: 'date',
            label: '[Date Day]',
            code: "{{$date_format_day}}"
        });
        self.ADVANCED_OPTIONS.push({
            id: 'advance_option_8',
            title: 'Date Day - Ordinal (jS)',
            type: 'date',
            label: '[Date Day - Ordinal]',
            code: "{{$date_format_day2}}"
        });
        // Add a separator
        self.ADVANCED_OPTIONS.push({
            id: 'advance_option_empty_99',
            title: '-----------------------------------',
            type: 'empty',
            label: 'empty',
            code: ""
        });
        var unique_id = self.getUniqueValue();
        self.ADVANCED_OPTIONS.push({
            id: 'advance_option_9',
            title: 'Control: Input Text',
            type: 'input',
            label: '[Control: Input Text]',
            code: "<input type='text' id='"+ unique_id +"' name='"+ unique_id +"' value='"+ unique_id +"'>"
        });
        self.ADVANCED_OPTIONS.push({
            id: 'advance_option_10',
            title: 'Control: Textarea',
            type: 'textarea',
            label: '[Control: Textarea]',
            code: "<textarea cols='70' rows='5'> </textarea>"
        });

        self.ADVANCED_OPTIONS.push({
            id: 'advance_option_11',
            title: 'Control: Checkbox (Optional)',
            type: 'checkbox',
            label: '[Control: Checkbox]',
            code: "<input type='checkbox'>"
        });
        self.ADVANCED_OPTIONS.push({
            id: 'advance_option_11',
            title: 'Control: Checkbox (Required)',
            type: 'checkbox',
            label: '[Control: Checkbox]',
            code: "<input type='checkbox' required>"
        });
        self.ADVANCED_OPTIONS.push({
            id: 'advance_option_12',
            title: 'Control: Radio button (Optional)',
            type: 'radio',
            label: '[Control: Radio button]',
            code: "<input type='radio'>"
        });
        self.ADVANCED_OPTIONS.push({
            id: 'advance_option_12',
            title: 'Control: Radio button (Required)',
            type: 'radio',
            label: '[Control: Radio button]',
            code: "<input type='radio' required>"
        });
        self.ADVANCED_OPTIONS.push({
            id: 'advance_option_13',
            title: 'Control: Checkbox (PDPA OPTION 1)',
            type: 'checkbox',
            label: '[Control: Checkbox]',
            code: "<input type='checkbox' id='pdpa_option_1' name='pdpa_option_1' class='checkbox_@{pdpa_option_1}'>"
        });
        self.ADVANCED_OPTIONS.push({
            id: 'advance_option_14',
            title: 'Control: Checkbox (PDPA OPTION 2)',
            type: 'checkbox',
            label: '[Control: Checkbox]',
            code: "<input type='checkbox' id='pdpa_option_2' name='pdpa_option_2' class='checkbox_@{pdpa_option_2}'>"
        });
    }

    setPropertyOptions() {
        const self = this;

        self.PROPERTY_OPTIONS.push({
            id: 'property_1',
            title: 'Property Name',
            type: 'text',
            label: '[Property Name]',
            code: '{{$property_name}}'
        });
        self.PROPERTY_OPTIONS.push({
            id: 'property_2',
            title: 'Developer Name',
            type: 'text',
            label: '[Developer Name]',
            code: '{{$developer_name}}'
        });
        self.PROPERTY_OPTIONS.push({
            id: 'property_3',
            title: 'Developer Legal Name',
            type: 'text',
            label: '[Developer Legal Name]',
            code: '{{$developer_legal_name}}'
        });
        self.PROPERTY_OPTIONS.push({
            id: 'property_6',
            title: 'Developer Address',
            type: 'text',
            label: '[Developer Address]',
            code: '{{$developer_address}}'
        });
        self.PROPERTY_OPTIONS.push({
            id: 'property_4',
            title: 'Property Mukim Lot Number',
            type: 'text',
            label: '[Property Mukim Lot Number]',
            code: '{{$property_mukim_lot_number}}'
        });
        self.PROPERTY_OPTIONS.push({
            id: 'property_5',
            title: 'Property Location',
            type: 'text',
            label: '[Property Location]',
            code: '{{$property_location}}'
        });
    }

    setReissueOptions() {
        const self = this;

        self.REISSUE_OPTIONS.push({
            id: self.getUniqueValue(),
            title: 'New buyer 1 Name',
            type: 'text',
            label: '[New buyer 1 Name]',
            code: '{{$newly_added_buyer1_name}}'
        });

        self.REISSUE_OPTIONS.push({
            id: self.getUniqueValue(),
            title: 'New buyer 1 Identity',
            type: 'text',
            label: '[New buyer 1 Identity]',
            code: '{{$newly_added_buyer1_identity}}'
        });
        self.REISSUE_OPTIONS.push({
            id: self.getUniqueValue(),
            title: 'New buyer 2 Name',
            type: 'text',
            label: '[New buyer 2 Name]',
            code: '{{$newly_added_buyer2_name}}'
        });
        self.REISSUE_OPTIONS.push({
            id: self.getUniqueValue(),
            title: 'New buyer 2 Identity',
            type: 'text',
            label: '[New buyer 2 Identity]',
            code: '{{$newly_added_buyer2_identity}}'
        });
        self.REISSUE_OPTIONS.push({
            id: self.getUniqueValue(),
            title: 'Removed buyer 1 Name',
            type: 'text',
            label: '[Removed buyer 1 Name]',
            code: '{{$removed_buyer1_name}}'
        });
        self.REISSUE_OPTIONS.push({
            id: self.getUniqueValue(),
            title: 'Removed buyer 1 Identity',
            type: 'text',
            label: '[Removed buyer 1 Identity]',
            code: '{{$removed_buyer1_identity}}'
        });
        self.REISSUE_OPTIONS.push({
            id: self.getUniqueValue(),
            title: 'Removed buyer 1 Signature',
            type: 'text',
            label: '[Removed buyer 1 Signature]',
            code: '@{REMOVED_BUYER1_SIGNATURE}'
        });
        
        self.REISSUE_OPTIONS.push({
            id: self.getUniqueValue(),
            title: 'Removed buyer 2 Name',
            type: 'text',
            label: '[Removed buyer 2 Name]',
            code: '{{$removed_buyer2_name}}'
        });
        self.REISSUE_OPTIONS.push({
            id: self.getUniqueValue(),
            title: 'Removed buyer 2 Identity',
            type: 'text',
            label: '[Removed buyer 2 Identity]',
            code: '{{$removed_buyer2_identity}}'
        });
        self.REISSUE_OPTIONS.push({
            id: self.getUniqueValue(),
            title: 'Removed buyer 2 Signature',
            type: 'text',
            label: '[Removed buyer 2 Signature]',
            code: '@{REMOVED_BUYER2_SIGNATURE}'
        });

        self.REISSUE_OPTIONS.push({
            id: self.getUniqueValue(),
            title: 'Remaining buyer 1 Name',
            type: 'text',
            label: '[Remaining buyer 1 Name]',
            code: '{{$remaining_buyer1_name}}'
        });
        self.REISSUE_OPTIONS.push({
            id: self.getUniqueValue(),
            title: 'Remaining buyer 1 Identity',
            type: 'text',
            label: '[Remaining buyer 1 Identity]',
            code: '{{$remaining_buyer1_identity}}'
        });

        self.REISSUE_OPTIONS.push({
            id: self.getUniqueValue(),
            title: 'Remaining buyer 2 Name',
            type: 'text',
            label: '[Remaining buyer 2 Name]',
            code: '{{$remaining_buyer2_name}}'
        });
        self.REISSUE_OPTIONS.push({
            id: self.getUniqueValue(),
            title: 'Remaining buyer 2 Identity',
            type: 'text',
            label: '[Remaining buyer 2 Identity]',
            code: '{{$remaining_buyer2_identity}}'
        });
        
        self.REISSUE_OPTIONS.push({
            id: self.getUniqueValue(),
            title: 'Original Sale Block No',
            type: 'text',
            label: '[Original Sale Block No]',
            code: '{{$original_sale_block_no}}'
        });

        self.REISSUE_OPTIONS.push({
            id: self.getUniqueValue(),
            title: 'Original Sale Unit No',
            type: 'text',
            label: '[Original Sale Unit No]',
            code: '{{$original_sale_unit_no}}'
        });

        self.REISSUE_OPTIONS.push({
            id: self.getUniqueValue(),
            title: 'Original Sale Post Code',
            type: 'text',
            label: '[Original Sale Post Code]',
            code: '{{$original_sale_post_code}}'
        });

        self.REISSUE_OPTIONS.push({
            id: self.getUniqueValue(),
            title: 'Original Sale Booking Fee (5%)',
            type: 'text',
            label: '[Original Sale Booking Fee (5%)]',
            code: '{{$original_sale_booking_fee_5_percent}}'
        });

        self.REISSUE_OPTIONS.push({
            id: self.getUniqueValue(),
            title: 'Original Sale 5% Booking Fee of 25%',
            type: 'text',
            label: '[Original Sale 5% Booking Fee of 25%]',
            code: '{{$booking_fee_5_percent_of_25_percent}}'
        });

        self.REISSUE_OPTIONS.push({
            id: self.getUniqueValue(),
            title: 'Original Sale 15% Purchase Price',
            type: 'text',
            label: '[Original Sale 15% Purchase Price]',
            code: '{{$original_sale_15_percent_purchase_price}}'
        });

        self.REISSUE_OPTIONS.push({
            id: self.getUniqueValue(),
            title: 'Original Sale 5% Difference',
            type: 'text',
            label: '[Original Sale 5% Difference]',
            code: '{{$original_fee_5_percent_difference}}'
        });
    }

    setEOIOptions() {
        const self = this;

        self.EOI_OPTIONS.push({
            id: self.getUniqueValue(),
            title: 'EOI Number',
            type: 'text',
            label: '[EOI Number]',
            code: '{{$eoi_no}}'
        });
        self.EOI_OPTIONS.push({
            id: self.getUniqueValue(),
            title: 'EOI Barcode',
            type: 'text',
            label: '[EOI Barcode]',
            code: "<img alt='EOI Barcode' src='"+ self.SSHttpService.getApiURL('eois/barcode-image/{{$eoi_no}}') +"'>"
        });
    }

    setCurrentUserOptions() {
        const self = this;

        self.CURRENT_USER_OPTIONS.push({
            id: self.getUniqueValue(),
            title: 'First Name',
            type: 'text',
            label: '[First Name]',
            code: '{{$current_user_first_name}}'
        });
        self.CURRENT_USER_OPTIONS.push({
            id: self.getUniqueValue(),
            title: 'Last Name',
            type: 'text',
            label: '[Last Name]',
            code: '{{$current_user_last_name}}'
        });
        self.CURRENT_USER_OPTIONS.push({
            id: self.getUniqueValue(),
            title: 'Display Name',
            type: 'text',
            label: '[Display Name]',
            code: '{{$current_user_display_name}}'
        });
        self.CURRENT_USER_OPTIONS.push({
            id: self.getUniqueValue(),
            title: 'Email',
            type: 'text',
            label: '[Email]',
            code: '{{$current_user_email}}'
        });
        self.CURRENT_USER_OPTIONS.push({
            id: self.getUniqueValue(),
            title: 'Phone Number',
            type: 'text',
            label: '[Phone Number]',
            code: '{{$current_user_phone}}'
        });
        self.CURRENT_USER_OPTIONS.push({
            id: self.getUniqueValue(),
            title: 'Signature',
            type: 'text',
            label: 'Signature',
            code: '@{CURRENT_USER_SIGNATURE}'
        }); 
    }

    setUnitOptions() {
        const self = this;

        self.UNIT_OPTIONS.push({
            id: 'unit_1',
            title: 'OTP No',
            type: 'text',
            label: '[OTP No]',
            code: '{{$otp_no}}'
        });
        self.UNIT_OPTIONS.push({
            id: self.getUniqueValue(),
            title: 'ex OTP No',
            type: 'text',
            label: '[ex OTP No]',
            code: '{{$ex_otp_no}}'
        });
        self.UNIT_OPTIONS.push({
            id: 'unit_1_1',
            title: 'Original OTP No',
            type: 'text',
            label: '[Original OTP No]',
            code: '{{$original_otp_no}}'
        });
        self.UNIT_OPTIONS.push({
            id: 'unit_1_2',
            title: 'Previous OTP No',
            type: 'text',
            label: '[Previous OTP No]',
            code: '{{$previous_otp_no}}'
        });
        self.UNIT_OPTIONS.push({
            id: 'unit_2',
            title: 'OTP Date',
            type: 'text',
            label: '[OTP Date]',
            code: '{{$otp_date}}'
        });
        self.UNIT_OPTIONS.push({
            id: 'unit_3',
            title: 'Unit Number',
            type: 'text',
            label: '[Unit Number]',
            code: '{{$unit_number}}'
        });
        self.UNIT_OPTIONS.push({
            id: 'unit_4',
            title: 'Unit Block No',
            type: 'text',
            label: '[Unit Block No]',
            code: '{{$unit_block_no}}'
        });
        self.UNIT_OPTIONS.push({
            id: 'unit_5',
            title: 'Unit Block Name',
            type: 'text',
            label: '[Unit Block Name]',
            code: '{{$unit_block_name}}'
        });
        self.UNIT_OPTIONS.push({
            id: 'unit_6',
            title: 'Unit Block Postcode',
            type: 'text',
            label: '[Unit Block Postcode]',
            code: '{{$unit_block_postcode}}'
        });
        self.UNIT_OPTIONS.push({
            id: self.getUniqueValue(),
            title: 'Unit Share Value',
            type: 'text',
            label: '[Unit Share Value]',
            code: '{{$unit_share_value}}'
        });
        self.UNIT_OPTIONS.push({
            id: self.getUniqueValue(),
            title: 'Floor Plan Name',
            type: 'text',
            label: '[Floor Plan Name]',
            code: '{{$floorplan_name}}'
        });
        self.UNIT_OPTIONS.push({
            id: self.getUniqueValue(),
            title: 'Floor No',
            type: 'text',
            label: '[Floor No]',
            code: '{{$floor_no}}'
        });
        self.UNIT_OPTIONS.push({
            id: self.getUniqueValue(),
            title: 'Ordinal Floor No',
            type: 'text',
            label: '[Ordinal Floor No]',
            code: '{{$ordinal_floor_no}}'
        });
        self.UNIT_OPTIONS.push({
            id: self.getUniqueValue(),
            title: 'Floor Plan Size (per m2)',
            type: 'text',
            label: '[Floor Plan Size (per m2)]',
            code: '{{$floorplan_size_m2}}'
        });
        self.UNIT_OPTIONS.push({
            id: 'unit_7',
            title: 'List Price',
            type: 'text',
            label: '[List Price]',
            code: '{{$unit_price}}'
        });
        self.UNIT_OPTIONS.push({
            id: 'unit_8',
            title: 'Sale Price',
            type: 'text',
            label: '[Sale Price]',
            code: '{{$sale_price_in_no}}'
        });
        self.UNIT_OPTIONS.push({
            id: 'unit_9',
            title: 'Sale Price (per m2)',
            type: 'text',
            label: '[Sale Price (per m2)]',
            code: '{{$sale_price_m2}}'
        });
        self.UNIT_OPTIONS.push({
            id: 'unit_10',
            title: 'Sale Price (per ft2)',
            type: 'text',
            label: '[Sale Price (per ft2)]',
            code: '{{$sale_price_ft2}}'
        });
        self.UNIT_OPTIONS.push({
            id: self.getUniqueValue(),
            title: 'Sale Price Exclusive GST',
            type: 'text',
            label: '[Sale Price Exclusive GST]',
            code: '{{$sale_price_exclusive_gst}}'
        });
        self.UNIT_OPTIONS.push({
            id: self.getUniqueValue(),
            title: 'Sale GST Percent',
            type: 'text',
            label: '[Sale GST Percent]',
            code: '{{$sale_gst_percent}}'
        });
        self.UNIT_OPTIONS.push({
            id: self.getUniqueValue(),
            title: 'Sale GST Amount',
            type: 'text',
            label: '[Sale GST Amount]',
            code: '{{$sale_gst_amount}}'
        });
        self.UNIT_OPTIONS.push({
            id: self.getUniqueValue(),
            title: 'Sale Price Inclusive GST',
            type: 'text',
            label: '[Sale Price Inclusive GST]',
            code: '{{$sale_price_inclusive_gst}}'
        });
        self.UNIT_OPTIONS.push({
            id: self.getUniqueValue(),
            title: 'Sale Marketing Scheme',
            type: 'text',
            label: '[Sale Marketing Scheme]',
            code: '{{$sale_marketing_scheme}}'
        });
        self.UNIT_OPTIONS.push({
            id: 'unit_11',
            title: 'Booking Fee (5%)',
            type: 'text',
            label: '[Booking Fee (5%)]',
            code: '{{$booking_fee}}'
        });
        self.UNIT_OPTIONS.push({
            id: 'unit_111',
            title: 'Balance Payment (15%)',
            type: 'text',
            label: '[Balance Payment (15%)]',
            code: '{{$balance_payment}}'
        });
        self.UNIT_OPTIONS.push({
            id: 'unit_1122',
            title: 'Balance Payment (20%)',
            type: 'text',
            label: '[Balance Payment (20%)]',
            code: '{{$balance_payment_20}}'
        });
        self.UNIT_OPTIONS.push({
            id: 'unit_1234',
            title: 'Payment Amount Balance (20%)',
            type: 'text',
            label: '[Payment Amount Balance (20%)]',
            code: '{{$payment_amount_balance_20_percent}}'
        });
        self.UNIT_OPTIONS.push({
            id: self.getUniqueValue(),
            title: 'Payment Amount Exclusive GST',
            type: 'text',
            label: '[Payment Amount Exclusive GST]',
            code: '{{$payment_amount_exclusive_gst}}'
        });
        self.UNIT_OPTIONS.push({
            id: self.getUniqueValue(),
            title: 'Payment Amount GST Percent',
            type: 'text',
            label: '[Payment Amount GST Percent]',
            code: '{{$payment_amount_gst_percent}}'
        });
        self.UNIT_OPTIONS.push({
            id: self.getUniqueValue(),
            title: 'Payment Amount GST Amount',
            type: 'text',
            label: '[Payment Amount GST Amount]',
            code: '{{$payment_amount_gst_amount}}'
        });
        self.UNIT_OPTIONS.push({
            id: self.getUniqueValue(),
            title: 'Payment Amount Inclusive GST',
            type: 'text',
            label: '[Payment Amount Inclusive GST]',
            code: '{{$payment_amount_inclusive_gst}}'
        });
        self.UNIT_OPTIONS.push({
            id: 'unit_12',
            title: 'Unit Floor Plan Image',
            type: 'image',
            label: '[Unit Floor Plan Image]',
            code: '{!!$unit_floorplan_asset_url!!}'
        });
        self.UNIT_OPTIONS.push({
            id: 'unit_13',
            title: 'Unit Annex A Image',
            type: 'image',
            label: '[Unit Annex A Image]',
            code: '{!!$unit_annex_a_asset_url!!}'
        });
        self.UNIT_OPTIONS.push({
            id: 'unit_14',
            title: 'Unit Annex D Annexure 3 Image',
            type: 'image',
            label: '[Unit Annex D Annexure 3 Image]',
            code: '{!!$unit_annex_d3_asset_url!!}'
        });

        self.UNIT_OPTIONS.push({
            id: 'unit_30',
            title: 'Unit Assigned By User Name',
            type: 'text',
            label: '[Unit Assigned By User Name]',
            code: '{$unit_assigned_by_user_name}'
        });
        self.UNIT_OPTIONS.push({
            id: 'unit_31',
            title: 'Unit Assigned By User Signature',
            type: 'image',
            label: '[Unit Assigned By User Signature]',
            code: '{!!$unit_assigned_by_user_signature!!}'
        });
        self.UNIT_OPTIONS.push({
            id: 'unit_32',
            title: 'Unit Allocated By User Name',
            type: 'text',
            label: '[Unit Allocated By User Name]',
            code: '{$unit_allocated_by_user_name}'
        });
        self.UNIT_OPTIONS.push({
            id: self.getUniqueValue(),
            title: 'Unit Allocation Remarks',
            type: 'text',
            label: '[Unit Allocation Remarks]',
            code: '{{$unit_allocation_remarks}}'
        });
        self.UNIT_OPTIONS.push({
            id: self.getUniqueValue(),
            title: 'Unit Assignment Remarks',
            type: 'text',
            label: '[Unit Assignment Remarks]',
            code: '{{$unit_assignment_remarks}}'
        });
        self.UNIT_OPTIONS.push({
            id: self.getUniqueValue(),
            title: 'PP Form Remarks',
            type: 'text',
            label: '[PP Form Remarks]',
            code: '{{$sale_pp_form_remarks}}'
        });
    }

    setAuthorisedOfficerOptions(){
        const self = this;

        // We are not using 'id' in updated implementation of editor
        // So, 'id' uniqueness doesn't matter or 'id' can be left blank/null

        // Pass following information to get option, i.e id, title, type, label, code
        // e.g. getOption(code, title, id = null, label = null, type = 'text')

        //-------------- self.getOption(code, title); -----------

        let salutation = self.getOption('{{$buyer_officer_salutation}}', 'Salutation');
        self.pushOption(self.AUTHORISED_OFFICER_OPTIONS, salutation);

        let gender = self.getOption('{{$buyer_officer_gender}}', 'Gender');
        self.pushOption(self.AUTHORISED_OFFICER_OPTIONS, gender);

        let marital_status = self.getOption('{{$buyer_officer_marital_status}}', 'Marital Status');
        self.pushOption(self.AUTHORISED_OFFICER_OPTIONS, marital_status);

        let first_name = self.getOption('{{$buyer_officer_first_name}}', 'First Name');
        self.pushOption(self.AUTHORISED_OFFICER_OPTIONS, first_name);

        //------------- self.getOption(code, title); -----------
        let last_name = self.getOption('{{$buyer_officer_last_name}}', 'Last Name');
        self.pushOption(self.AUTHORISED_OFFICER_OPTIONS, last_name);

        let legal_name = self.getOption('{{$buyer_officer_legal_name}}', 'Legal Name');
        self.pushOption(self.AUTHORISED_OFFICER_OPTIONS, legal_name);

        let identity_no = self.getOption('{{$buyer_officer_identity_no}}', 'Identity No');
        self.pushOption(self.AUTHORISED_OFFICER_OPTIONS, identity_no);

        let identity_type = self.getOption('{{$buyer_officer_identity_type}}', 'Identity Type');
        self.pushOption(self.AUTHORISED_OFFICER_OPTIONS, identity_type);

        let identity_img1 = self.getOption('{{!!$buyer_officer_identity_image1!!}}', 'Identity Image1');
        self.pushOption(self.AUTHORISED_OFFICER_OPTIONS, identity_img1);

        let identity_img2 = self.getOption('{{!!$buyer_officer_identity_image2!!}}', 'Identity Image2');
        self.pushOption(self.AUTHORISED_OFFICER_OPTIONS, identity_img2);

        let legale_name_and_identity = self.getOption('{{$buyer_officer_legal_name_and_identity_no}}', 'Legal Name and Identity No');
        self.pushOption(self.AUTHORISED_OFFICER_OPTIONS, legale_name_and_identity);

        //------------------ self.getOption(code, title); -----------
        let residence_type = self.getOption('{{$buyer_officer_residence_type}}', 'Residence Type');
        self.pushOption(self.AUTHORISED_OFFICER_OPTIONS, residence_type);

        let nationality = self.getOption('{{$buyer_officer_nationality_name}}', 'Nationality');
        self.pushOption(self.AUTHORISED_OFFICER_OPTIONS, nationality);

        let primary_address = self.getOption('{{$buyer_officer_primary_address}}', 'Primary Address Full');
        self.pushOption(self.AUTHORISED_OFFICER_OPTIONS, primary_address);

        let addressFields = {
            'line1' : 'Line 1',
            'line2' : 'Line 2',
            'unit_no' : 'Unit No',
            'city' : 'City',
            'district' : 'District',
            'province' : 'Province',
            'country_name' : 'Country Name',
            'postcode' : 'Postcode'
        };
        jQuery.each(addressFields, function(k, v) {
            self.pushOption(self.AUTHORISED_OFFICER_OPTIONS, self.getOption('{{$buyer_officer_primary_address_'+k+'}}', 'Primary Address ' + v));
        });

        let mailing_address = self.getOption('{{$buyer_officer_mailing_address}}', 'Mailing Address Full');
        self.pushOption(self.AUTHORISED_OFFICER_OPTIONS, mailing_address);

        jQuery.each(addressFields, function(k, v) {
            self.pushOption(self.AUTHORISED_OFFICER_OPTIONS, self.getOption('{{$buyer_officer_mailing_address_'+k+'}}', 'Mailing Address ' + v));
        });

        let email = self.getOption('{{$buyer_officer_email}}', 'Email');
        self.pushOption(self.AUTHORISED_OFFICER_OPTIONS, email);

        //----------- self.getOption(code, title); -----------
        let contact = self.getOption('{{$buyer_officer_contact}}', 'Contact');
        self.pushOption(self.AUTHORISED_OFFICER_OPTIONS, contact);

        let contact2 = self.getOption('{{$buyer_officer_contact2}}', 'Contact 2');
        self.pushOption(self.AUTHORISED_OFFICER_OPTIONS, contact2);

        let dob = self.getOption('{{$buyer_officer_dob}}', 'DOB');
        self.pushOption(self.AUTHORISED_OFFICER_OPTIONS, dob);

        let industry = self.getOption('{{$buyer_officer_industry}}', 'Industry');
        self.pushOption(self.AUTHORISED_OFFICER_OPTIONS, industry);

        let occupation = self.getOption('{{$buyer_officer_occupation}}', 'Occupation');
        self.pushOption(self.AUTHORISED_OFFICER_OPTIONS, occupation);

        //-------------- self.getOption(code, title); -----------
        let signatures = self.getOption('@{BUYER_OFFICER_SIGNATURE}', 'Signatures');
        self.pushOption(self.AUTHORISED_OFFICER_OPTIONS, signatures);

        // Add a separator
        //-----------   self.getOption(code, title, id = null, label = null, type = 'text');
        let separator = self.getOption("", '-----------------------------------', null, 'empty');
        self.pushOption(self.AUTHORISED_OFFICER_OPTIONS, separator);

        // Set QUESTIONNAIRE_OPTIONS against each buyer
        $.each(self.propertyQuestions, function (index, propertyQuestion) {

            let code = '@{BUYER_OFFICER_Q' + propertyQuestion.code + '}';
            let title = 'Q ' + (index+1) + ' - ' + propertyQuestion.code;
            let label = '[Q:' + propertyQuestion.code + ']';
            let id = 'questions_option__officer_' + index;

            //------------------------ self.getOption(code, title, id = null, label = null, type = 'text'); -----------
            let questionnaire_option = self.getOption(code, title, id, label);
            self.pushOption(self.AUTHORISED_OFFICER_OPTIONS, questionnaire_option);
        });
    
    }

    setBuyerOptions() {
        const self = this;

        // We are not using 'id' in updated implementation of editor
        // So, 'id' uniqueness doesn't matter or 'id' can be left blank/null

        jQuery.each(self.buyersNo, function (i, buyerNo) {

            // Pass following information to get option, i.e id, title, type, label, code
            // e.g. getOption(code, title, id = null, label = null, type = 'text')

            //-------------- self.getOption(code, title); -----------
            let buyer_type = self.getOption('{{$buyer' + buyerNo + '_type}}', 'Type');
            self.pushBuyerOption(i, buyer_type);

            let salutation = self.getOption('{{$buyer' + buyerNo + '_salutation}}', 'Salutation');
            self.pushBuyerOption(i, salutation);

            let gender = self.getOption('{{$buyer' + buyerNo + '_gender}}', 'Gender');
            self.pushBuyerOption(i, gender);

            let marital_status = self.getOption('{{$buyer' + buyerNo + '_marital_status}}', 'Marital Status');
            self.pushBuyerOption(i, marital_status);

            let first_name = self.getOption('{{$buyer' + buyerNo + '_first_name}}', 'First Name');
            self.pushBuyerOption(i, first_name);

            //------------- self.getOption(code, title); -----------
            let last_name = self.getOption('{{$buyer' + buyerNo + '_last_name}}', 'Last Name');
            self.pushBuyerOption(i, last_name);

            let legal_name = self.getOption('{{$buyer' + buyerNo + '_legal_name}}', 'Legal Name');
            self.pushBuyerOption(i, legal_name);

            let identity_no = self.getOption('{{$buyer' + buyerNo + '_identity_no}}', 'Identity No');
            self.pushBuyerOption(i, identity_no);

            let identity_type = self.getOption('{{$buyer' + buyerNo + '_identity_type}}', 'Identity Type');
            self.pushBuyerOption(i, identity_type);

            self.pushBuyerOption(i, self.getOption('{{$buyer' + buyerNo + '_passport_issued_by}}', 'Passport Issued By'));
            self.pushBuyerOption(i, self.getOption('{{$buyer' + buyerNo + '_passport_issued_date}}', 'Passport Issued Date'));
            self.pushBuyerOption(i, self.getOption('{{$buyer' + buyerNo + '_passport_expiry_date}}', 'Passport Expiry Date'));

            let identity_img1 = self.getOption('{{!!$buyer' + buyerNo + '_identity_image1!!}}', 'Identity Image1');
            self.pushBuyerOption(i, identity_img1);

            let identity_img2 = self.getOption('{{!!$buyer' + buyerNo + '_identity_image2!!}}', 'Identity Image2');
            self.pushBuyerOption(i, identity_img2);

            let buyer_photo = self.getOption('{!!$buyer' + buyerNo + '_photo!!}', 'Buyer Photo');
            self.pushBuyerOption(i, buyer_photo);

            let legale_name_and_identity = self.getOption('{{$buyer' + buyerNo + '_legal_name_and_identity_no}}', 'Legal Name and Identity No');
            self.pushBuyerOption(i, legale_name_and_identity);

            self.pushBuyerOption(i, self.getOption('{{$buyer' + buyerNo + '_legal_name_with_beneficiaries}}', 'Legal Name with Beneficiaries'));

            //------------------ self.getOption(code, title); -----------
            let residence_type = self.getOption('{{$buyer' + buyerNo + '_residence_type}}', 'Residence Type');
            self.pushBuyerOption(i, residence_type);

            let nationality = self.getOption('{{$buyer' + buyerNo + '_nationality_name}}', 'Nationality');
            self.pushBuyerOption(i, nationality);

            let primary_address = self.getOption('{{$buyer' + buyerNo + '_primary_address}}', 'Primary Address Full');
            self.pushBuyerOption(i, primary_address);

            let addressFields = {
                'line1' : 'Line 1',
                'line2' : 'Line 2',
                'unit_no' : 'Unit No',
                'city' : 'City',
                'district' : 'District',
                'province' : 'Province',
                'country_name' : 'Country Name',
                'postcode' : 'Postcode'
            };
            jQuery.each(addressFields, function(k, v) {
                self.pushBuyerOption(i, self.getOption('{{$buyer' + buyerNo + '_primary_address_'+k+'}}', 'Primary Address ' + v));
            });

            let mailing_address = self.getOption('{{$buyer' + buyerNo + '_mailing_address}}', 'Mailing Address Full');
            self.pushBuyerOption(i, mailing_address);

            jQuery.each(addressFields, function(k, v) {
                self.pushBuyerOption(i, self.getOption('{{$buyer' + buyerNo + '_mailing_address_'+k+'}}', 'Mailing Address ' + v));
            });

            let email = self.getOption('{{$buyer' + buyerNo + '_email}}', 'Email');
            self.pushBuyerOption(i, email);

            //----------- self.getOption(code, title); -----------
            let contact = self.getOption('{{$buyer' + buyerNo + '_contact}}', 'Contact');
            self.pushBuyerOption(i, contact);

            let contact2 = self.getOption('{{$buyer' + buyerNo + '_contact2}}', 'Contact 2');
            self.pushBuyerOption(i, contact2);

            let dob = self.getOption('{{$buyer' + buyerNo + '_dob}}', 'DOB');
            self.pushBuyerOption(i, dob);

            let industry = self.getOption('{{$buyer' + buyerNo + '_industry}}', 'Industry');
            self.pushBuyerOption(i, industry);

            let occupation = self.getOption('{{$buyer' + buyerNo + '_occupation}}', 'Occupation');
            self.pushBuyerOption(i, occupation);

            if(i !== 1){
                //--------------   self.getOption(code, title); -----------
                let relationship = self.getOption('{{$buyer' + buyerNo + '_relationship}}', 'Relationship With First Buyer');
                self.pushBuyerOption(i, relationship);
            }

            // Mapping for "@{BUYER_SIGNATURE}" not exist on server side, 
            // it should be "@{BUYER1_SIGNATURE}" for current buyer's signatures

            if(buyerNo == ''){
                var signeeBuyerNo = 1;
            }
            else{
                var signeeBuyerNo = buyerNo;
            }

            //-------------- self.getOption(code, title); -----------
            let signatures = self.getOption('@{BUYER' + signeeBuyerNo + '_SIGNATURE}', 'Signatures');
            self.pushBuyerOption(i, signatures);

            // Add a separator
            //-----------   self.getOption(code, title, id = null, label = null, type = 'text');
            let separator = self.getOption("", '-----------------------------------', null, 'empty');
            self.pushBuyerOption(i, separator);

            // Set QUESTIONNAIRE_OPTIONS against each buyer
            $.each(self.propertyQuestions, function (index, propertyQuestion) {

                let code = '@{BUYER' + buyerNo + '_Q' + propertyQuestion.code + '}';
                let title = 'Q ' + (index+1) + ' - ' + propertyQuestion.code;
                let label = '[Q:' + propertyQuestion.code + ']';
                let id = 'questions_option_' + buyerNo + '_' + i;

                //------------------------ self.getOption(code, title, id = null, label = null, type = 'text'); -----------
                let questionnaire_option = self.getOption(code, title, id, label);
                self.pushBuyerOption(i, questionnaire_option);
            });
        });

        // Non buyer payee mappings
        for(var index = 1; index <= 6; index++){
            $.each(self.BUYER_OPTIONS, function(j, _option){

                let option = angular.copy(_option);
                
                if(option.code.includes('BUYER1_SIGNATURE')){
                    option.code = option.code.replace('BUYER1', 'NONBUYERPAYEE'+index);
                }
                else if(option.code.includes('BUYER')){
                    option.code = option.code.replace('BUYER', 'NON_BUYER_PAYEE'+index);
                } else {
                    option.code = option.code.replace('buyer', 'non_buyer_payee'+index);
                }
                option.id = option.id+'_'+index;

                if(index == 1)
                    self.NON_BUYER_PAYEE1_OPTIONS.push(option);
                if(index == 2)
                    self.NON_BUYER_PAYEE2_OPTIONS.push(option);
                if(index == 3)
                    self.NON_BUYER_PAYEE3_OPTIONS.push(option);
                if(index == 4)
                    self.NON_BUYER_PAYEE4_OPTIONS.push(option);
                if(index == 5)
                    self.NON_BUYER_PAYEE5_OPTIONS.push(option);
                if(index == 6)
                    self.NON_BUYER_PAYEE6_OPTIONS.push(option);
            });
        }

        // Witnesses mappings
        for(var index = 1; index <= 4; index++){
            $.each(self.BUYER_OPTIONS, function(j, _option){

                let option = angular.copy(_option);
                
                if(option.code.includes('BUYER1_SIGNATURE')){
                    option.code = option.code.replace('BUYER1', 'WITNESS'+index);
                }
                else if(option.code.includes('BUYER')){
                    option.code = option.code.replace('BUYER', 'WITNESS'+index);
                } else {
                    option.code = option.code.replace('buyer', 'witness'+index);
                }
                option.id = option.id+'_'+index;

                if(index == 1)
                    self.WITNESS1_OPTIONS.push(option);
                if(index == 2)
                    self.WITNESS2_OPTIONS.push(option);
                if(index == 3)
                    self.WITNESS3_OPTIONS.push(option);
                if(index == 4)
                    self.WITNESS4_OPTIONS.push(option);
            });
        }
        
        self.BUYER_OPTIONS.push({
            id: 'buyer_98',
            title: 'Buyer\'s Official Primary Address',
            type: 'text',
            label: '[Buyer\'s Official Primary Address]',
            code: '{{$buyer_official_primary_address}}'
        });

        self.BUYER_OPTIONS.push({
            id: 'buyer_99',
            title: 'Buyer\'s Official Mailing Address',
            type: 'text',
            label: '[Buyer\'s Official Mailing Address]',
            code: '{{$buyer_official_mailing_address}}'
        });

        self.BUYER_OPTIONS.push({
            id: self.getUniqueValue(),
            title: 'All Buyer\'s Legal Names',
            type: 'text',
            label: '[All Buyer\'s Legal Names]',
            code: '{{$all_buyer_legal_names}}'
        });

        self.BUYER_OPTIONS.push({
            id: self.getUniqueValue(),
            title: 'All Buyer\'s Legal Names & Identity No.',
            type: 'text',
            label: '[All Buyer\'s Legal Names & Identity No.]',
            code: '{{$all_buyer_legal_names_and_identity_no}}'
        });
    }

    pushBuyerOption(i, option){
        const self = this;

        if(i == 0){
            self.BUYER_OPTIONS.push(option);
        }
        else if(i == 1){
            self.BUYER1_OPTIONS.push(option);
        }
        else if(i == 2){
            self.BUYER2_OPTIONS.push(option);
        }
        else if(i == 3){
            self.BUYER3_OPTIONS.push(option);
        }
        else if(i == 4){
            self.BUYER4_OPTIONS.push(option);
        }
    }

    pushOption(destination, option){
        const self = this;

        if(!option || typeof destination != ('object' || 'Array')){
            console.log('Error in pushOption: option/destination is invalid');
            return;
        }

        try{
            destination.push(option);
        }
        catch(ex){
            console.log(ex);
        }
    }

    setBeneficiaryOptions() {
        const self = this;

        jQuery.each(self.beneficiaryNo, function (i, beneficiaryNo) {

            //-------------- self.getOption(code, title); -----------
            // let buyer_type = self.getOption('{{$beneficiary' + beneficiaryNo + '_exists}}', 'Beneficiary Exists');
            // self.pushBeneficiaryOption(i, buyer_type);

            let salutation = self.getOption('{{$beneficiary' + beneficiaryNo + '_salutation}}', 'Salutation');
            self.pushBeneficiaryOption(i, salutation);

            let legal_name = self.getOption('{{$beneficiary' + beneficiaryNo + '_legal_name}}', 'Legal Name');
            self.pushBeneficiaryOption(i, legal_name);

            let legale_name_and_identity = self.getOption('{{$beneficiary' + beneficiaryNo + '_legal_name_and_identity_no}}', 'Legal Name & Identity No.');
            self.pushBeneficiaryOption(i, legale_name_and_identity);

            let identity_no = self.getOption('{{$beneficiary' + beneficiaryNo + '_identity_no}}', 'Identity No');
            self.pushBeneficiaryOption(i, identity_no);

            let identity_type = self.getOption('{{$beneficiary' + beneficiaryNo + '_identity_type}}', 'Identity Type');
            self.pushBeneficiaryOption(i, identity_type);

            let dob = self.getOption('{{$beneficiary' + beneficiaryNo + '_dob}}', 'DOB');
            self.pushBeneficiaryOption(i, dob);

            let identity_img1 = self.getOption('{{!!$beneficiary' + beneficiaryNo + '_identity_image1!!}}', 'Identity Image1');
            self.pushBeneficiaryOption(i, identity_img1);

            let identity_img2 = self.getOption('{{!!$beneficiary' + beneficiaryNo + '_identity_image2!!}}', 'Identity Image2');
            self.pushBeneficiaryOption(i, identity_img2);

            let addressFields = {
                'line1' : 'Line 1',
                'line2' : 'Line 2',
                'unit_no' : 'Unit No',
                'city' : 'City',
                'district' : 'District',
                'province' : 'Province',
                'country_name' : 'Country Name',
                'postcode' : 'Postcode'
            };
            jQuery.each(addressFields, function(k, v) {
                self.pushBeneficiaryOption(i, self.getOption('{{$beneficiary' + beneficiaryNo + '_primary_address_'+k+'}}', 'Primary Address ' + v));
            });

        });
    }

    getOption(code, title, id = null, label = null, type = 'text'){
        const self = this;

        // 'title' and 'label' are same expect 'label' is wrapped inside [] 

        let option = {
            id: id ? id : self.getUniqueValue(),
            title: title,
            label: label ? label : "[" + title + "]",
            code: code,
            type: type,
        };

        return option;
    }

    pushBeneficiaryOption(i, option){
        const self = this;

        if(i == 0){
            self.BENEFICIARY1_OPTIONS.push(option);
        }
        else if(i == 1){
            self.BENEFICIARY2_OPTIONS.push(option);
        }
    }

    setSignatureOptions() {
        const self = this;

        self.SIGNATURE_OPTIONS.push({
            id: 'buyer_sign_1',
            title: 'All Signatures',
            type: 'text',
            label: '[All Signatures]',
            code: '@{ALL_SIGNATURES}'
        });
    }

    // setQuestionsOptions() {
    //     const self = this;

    //     if (!self.propertyQuestions) {
    //         return;
    //     }

    //     let buyersNo = ['1', '2', '3'];
    //     jQuery.each(buyersNo, function (i, buyerNo) {
    //         jQuery.each(self.propertyQuestions, function (i, propertyQuestion) {
    //             self.QUESTIONNAIRE_OPTIONS.push({
    //                 id: 'questions_option_' + buyerNo + '_' + i,
    //                 title: propertyQuestion.question_text,
    //                 type: 'text',
    //                 label: '[Q:' + propertyQuestion.code + ']',
    //                 code: '@{BUYER' + buyerNo + '_Q' + propertyQuestion.code + '}'
    //             });
    //         });
    //     });
    // }

    setPaymentOptions() {
        const self = this;

        let array = ['1', '2'];
        jQuery.each(array, function (i, no) {
            self.PAYMENT_OPTIONS.push({
                id: 'payment_instrument' + no + '_1',
                title: 'Payment Instrument' + no+ ' Bank Name',
                type: 'text',
                label: '[Payment Instrument' + no + ' Bank Name]',
                code: '{{$payment_instrument' + no + '_bank_name}}'
            });
            self.PAYMENT_OPTIONS.push({
                id: 'payment_instrument' + no + '_2',
                title: 'Payment Instrument' + no+ ' Bank Code',
                type: 'text',
                label: '[Payment Instrument' + no + ' Bank Code]',
                code: '{{$payment_instrument' + no + '_bank_code}}'
            });
            self.PAYMENT_OPTIONS.push({
                id: 'payment_instrument' + no + '_3',
                title: 'Payment Instrument' + no+ ' Bank-In Code',
                type: 'text',
                label: '[Payment Instrument' + no + ' Bank-In Date]',
                code: '{{$payment_instrument' + no + '_bank_in_date}}'
            });
            self.PAYMENT_OPTIONS.push({
                id: 'payment_instrument' + no + '_4',
                title: 'Payment Instrument' + no+ ' Instrument No',
                type: 'text',
                label: '[Payment Instrument' + no + ' Instrument No]',
                code: '{{$payment_instrument' + no + '_instrument_no}}'
            });
            self.PAYMENT_OPTIONS.push({
                id: 'payment_instrument' + no + '_4',
                title: 'Payment Instrument' + no+ ' Amount',
                type: 'text',
                label: '[Payment Instrument' + no + ' Amount]',
                code: '{{$payment_instrument' + no + '_amount}}'
            });
            self.PAYMENT_OPTIONS.push({
                id: 'payment_instrument' + no + '_5',
                title: 'Payment Instrument' + no+ ' Cheque Image',
                type: 'image',
                label: '[Payment Instrument' + no + ' Cheque Image]',
                code: '{!!$payment_instrument' + no + '_cheque_image!!}'
            });
        });

        self.PAYMENT_OPTIONS.push({
            id: 'payment_option_98',
            title: 'All Payment Instruments Nos',
            type: 'text',
            label: '[All Payment Instruments Nos]',
            code: '@{payment_instruments_all_nos}'
        });
        self.PAYMENT_OPTIONS.push({
            id: 'payment_option_99',
            title: 'Total Payment Amount',
            type: 'text',
            label: '[Total Payment Amount]',
            code: '@{payment_amount}'
        });
        self.PAYMENT_OPTIONS.push({
            id: 'payment_option_100',
            title: 'Total Payment Amount Percentage',
            type: 'text',
            label: '[Total Payment Amount Percentage]',
            code: '@{payment_amount_percentage}'
        });

        self.PAYMENT_OPTIONS.push({
            id: 'payment_option_101',
            title: 'Total Interest Paid Amount',
            type: 'text',
            label: '[Total Interest Paid Amount]',
            code: '{{$total_interest_paid_amount}}'
        });
        self.PAYMENT_OPTIONS.push({
            id: 'payment_option_102',
            title: 'Interest Paid Date',
            type: 'text',
            label: '[Interest Paid Date]',
            code: '{{$interest_paid_date}}'
        });
        self.PAYMENT_OPTIONS.push({
            id: 'payment_option_103',
            title: 'Total Payment Amount Sum',
            type: 'text',
            label: '[Total Payment Amount Sum]',
            code: '{{$total_payment_amount}}'
        });
        self.PAYMENT_OPTIONS.push({
            id: 'payment_option_104',
            title: 'Total Payment Amount Percentage Sum',
            type: 'text',
            label: '[Total Payment Amount Percentage Sum]',
            code: '{{$total_payment_amount_percentage}}'
        });
        self.PAYMENT_OPTIONS.push({
            id: 'payment_option_105',
            title: 'Sale Price Less Booking Fee',
            type: 'text',
            label: '[Sale Price Less Booking Fee]',
            code: '{{$balance_amount_after_booking_fee}}'
        });
    }

    setLawyerOptions() {
        const self = this;

        let lawyer_option = self.getOption('{{$law_firm_name}}', 'Law Firm Name');
        self.pushOption(self.LAWYER_OPTIONS, lawyer_option);

        lawyer_option = self.getOption('{{$law_firm_code}}', 'Law Firm Code');
        self.pushOption(self.LAWYER_OPTIONS, lawyer_option);

        lawyer_option = self.getOption('{{$lawyer_name}}', 'Lawyer Name');
        self.pushOption(self.LAWYER_OPTIONS, lawyer_option);

        lawyer_option = self.getOption('{{$lawyer_email}}', 'Lawyer Email');
        self.pushOption(self.LAWYER_OPTIONS, lawyer_option);

        lawyer_option = self.getOption('{{$lawyer_phone}}', 'Lawyer Phone');
        self.pushOption(self.LAWYER_OPTIONS, lawyer_option);

        lawyer_option = self.getOption('{{$remarks_for_lawyer}}', 'Remarks for Lawyer');
        self.pushOption(self.LAWYER_OPTIONS, lawyer_option);

        lawyer_option = self.getOption('{{$requested_spa_issue_date}}', 'Requested SPA Issue Date');
        self.pushOption(self.LAWYER_OPTIONS, lawyer_option);

        self.LAWYER_OPTIONS.push({
            id: self.getUniqueValue(),
            title: '-----------------',
            type: 'text',
            label: '',
            code: ''
        });

        $.each(self.LAWYER_OPTIONS, function(i, option){
            let _option = angular.copy(option);
            if(_option.code !== ''){
                _option.code = (_option.code.replace("{{$", "@{")).replace("}}", "}");
                _option.title = _option.title + " (Editable)";
                self.pushOption(self.LAWYER_OPTIONS, _option);
            }
        });
    }

    // Following options for editable values
    setBrokerOptions() {
        const self = this;

        let sales_broker_agency_name = self.getOption('@{sales_broker_agency_name}', 'Sales broker Agency Name');
        self.pushOption(self.BROKER_OPTIONS, sales_broker_agency_name);

        let sales_broker_agency_cea_license = self.getOption('@{sales_broker_agency_cea_license}', 'Sales broker Agency CEA License');
        self.pushOption(self.BROKER_OPTIONS, sales_broker_agency_cea_license);

        let sales_broker_reg_no = self.getOption('@{sales_broker_reg_no}', 'Sales broker Reg. No.');
        self.pushOption(self.BROKER_OPTIONS, sales_broker_reg_no);

        let sales_broker_name = self.getOption('@{sales_broker_name}', 'Sales broker Name');
        self.pushOption(self.BROKER_OPTIONS, sales_broker_name);

        let sales_broker_email = self.getOption('@{sales_broker_email}', 'Sales broker Email');
        self.pushOption(self.BROKER_OPTIONS, sales_broker_email);

        let sales_broker_phone = self.getOption('@{sales_broker_phone}', 'Sales broker Phone');
        self.pushOption(self.BROKER_OPTIONS, sales_broker_phone);

        let sale_remarks = self.getOption('@{sale_remarks}', 'Agent Remarks');
        self.pushOption(self.BROKER_OPTIONS, sale_remarks);

        // ---------  Sales Consultant  ----------
        let broker_sc_name = self.getOption('@{broker_sc_name}', 'Sales Consultant Name');
        self.pushOption(self.BROKER_OPTIONS, broker_sc_name);

        let broker_sc_email = self.getOption('@{broker_sc_email}', 'Sales Consultant Email');
        self.pushOption(self.BROKER_OPTIONS, broker_sc_email);

        let broker_sc_phone = self.getOption('@{broker_sc_phone}', 'Sales Consultant Phone');
        self.pushOption(self.BROKER_OPTIONS, broker_sc_phone);

        let broker_sc_reg_no = self.getOption('@{broker_sc_reg_no}', 'Sales Consultant Reg No');
        self.pushOption(self.BROKER_OPTIONS, broker_sc_reg_no);

        let broker_sc_agency_name = self.getOption('@{broker_sc_agency_name}', 'Sales Consultant Agency Name');
        self.pushOption(self.BROKER_OPTIONS, broker_sc_agency_name);

        let broker_sc_agency_cea_license = self.getOption('@{broker_sc_agency_cea_license}', 'Sales Consultant Agency CEA License');
        self.pushOption(self.BROKER_OPTIONS, broker_sc_agency_cea_license);

        // ---------  Main Agent  ---------
        let broker_main_name = self.getOption('@{broker_main_name}', 'Main Agent Name');
        self.pushOption(self.BROKER_OPTIONS, broker_main_name);

        let broker_main_email = self.getOption('@{broker_main_email}', 'Main Agent Email');
        self.pushOption(self.BROKER_OPTIONS, broker_main_email);

        let broker_main_phone = self.getOption('@{broker_main_phone}', 'Main Agent Phone');
        self.pushOption(self.BROKER_OPTIONS, broker_main_phone);

        let broker_main_reg_no = self.getOption('@{broker_main_reg_no}', 'Main Agent Reg No');
        self.pushOption(self.BROKER_OPTIONS, broker_main_reg_no);

        let broker_main_agency_name = self.getOption('@{broker_main_agency_name}', 'Main Agent Agency Name');
        self.pushOption(self.BROKER_OPTIONS, broker_main_agency_name);

        let broker_main_agency_cea_license = self.getOption('@{broker_main_agency_cea_license}', 'Main Agent Agency CEA License');
        self.pushOption(self.BROKER_OPTIONS, broker_main_agency_cea_license);

        // -----------  Co-Broker  -----------
        let broker_co_name = self.getOption('@{broker_co_name}', 'Co-Broker Name');
        self.pushOption(self.BROKER_OPTIONS, broker_co_name);

        let broker_co_email = self.getOption('@{broker_co_email}', 'Co-Broker Email');
        self.pushOption(self.BROKER_OPTIONS, broker_co_email);

        let broker_co_phone = self.getOption('@{broker_co_phone}', 'Co-Broker Phone');
        self.pushOption(self.BROKER_OPTIONS, broker_co_phone);

        let broker_co_reg_no = self.getOption('@{broker_co_reg_no}', 'Co-Broker Reg No');
        self.pushOption(self.BROKER_OPTIONS, broker_co_reg_no);

        let broker_co_agency_name = self.getOption('@{broker_co_agency_name}', 'Co-Broker Agency Name');
        self.pushOption(self.BROKER_OPTIONS, broker_co_agency_name);

        let broker_co_agency_cea_license = self.getOption('@{broker_co_agency_cea_license}', 'Co-Broker Agency CEA License');
        self.pushOption(self.BROKER_OPTIONS, broker_co_agency_cea_license);

    }

    // Following options for normal laravel template values
    setBrokerOptions1() {
        const self = this;

        let sales_broker_agency_name = self.getOption('{{$sales_broker_agency_name}}', 'Sales broker Agency Name');
        self.pushOption(self.BROKER_OPTIONS_1, sales_broker_agency_name);

        let sales_broker_agency_cea_license = self.getOption('{{$sales_broker_agency_cea_license}}', 'Sales broker Agency CEA License');
        self.pushOption(self.BROKER_OPTIONS_1, sales_broker_agency_cea_license);

        let sales_broker_reg_no = self.getOption('{{$sales_broker_reg_no}}', 'Sales broker Reg. No.');
        self.pushOption(self.BROKER_OPTIONS_1, sales_broker_reg_no);

        let sales_broker_name = self.getOption('{{$sales_broker_name}}', 'Sales broker Name');
        self.pushOption(self.BROKER_OPTIONS_1, sales_broker_name);

        let sales_broker_email = self.getOption('{{$sales_broker_email}}', 'Sales broker Email');
        self.pushOption(self.BROKER_OPTIONS_1, sales_broker_email);

        let sales_broker_phone = self.getOption('{{$sales_broker_phone}}', 'Sales broker Phone');
        self.pushOption(self.BROKER_OPTIONS_1, sales_broker_phone);

        let sale_remarks = self.getOption('{{$sale_remarks}}', 'Agent Remarks');
        self.pushOption(self.BROKER_OPTIONS_1, sale_remarks);

        // ---------  Sales Consultant  ----------
        let broker_sc_name = self.getOption('{{$broker_sc_name}}', 'Sales Consultant Name');
        self.pushOption(self.BROKER_OPTIONS_1, broker_sc_name);

        let broker_sc_email = self.getOption('{{$broker_sc_email}}', 'Sales Consultant Email');
        self.pushOption(self.BROKER_OPTIONS_1, broker_sc_email);

        let broker_sc_phone = self.getOption('{{$broker_sc_phone}}', 'Sales Consultant Phone');
        self.pushOption(self.BROKER_OPTIONS_1, broker_sc_phone);

        let broker_sc_reg_no = self.getOption('{{$broker_sc_reg_no}}', 'Sales Consultant Reg No');
        self.pushOption(self.BROKER_OPTIONS_1, broker_sc_reg_no);

        let broker_sc_agency_name = self.getOption('{{$broker_sc_agency_name}}', 'Sales Consultant Agency Name');
        self.pushOption(self.BROKER_OPTIONS_1, broker_sc_agency_name);

        let broker_sc_agency_cea_license = self.getOption('{{$broker_sc_agency_cea_license}}', 'Sales Consultant Agency CEA License');
        self.pushOption(self.BROKER_OPTIONS_1, broker_sc_agency_cea_license);

        // ---------  Main Agent  ---------
        let broker_main_name = self.getOption('{{$broker_main_name}}', 'Main Agent Name');
        self.pushOption(self.BROKER_OPTIONS_1, broker_main_name);

        let broker_main_email = self.getOption('{{$broker_main_email}}', 'Main Agent Email');
        self.pushOption(self.BROKER_OPTIONS_1, broker_main_email);

        let broker_main_phone = self.getOption('{{$broker_main_phone}}', 'Main Agent Phone');
        self.pushOption(self.BROKER_OPTIONS_1, broker_main_phone);

        let broker_main_reg_no = self.getOption('{{$broker_main_reg_no}}', 'Main Agent Reg No');
        self.pushOption(self.BROKER_OPTIONS_1, broker_main_reg_no);

        let broker_main_agency_name = self.getOption('{{$broker_main_agency_name}}', 'Main Agent Agency Name');
        self.pushOption(self.BROKER_OPTIONS_1, broker_main_agency_name);

        let broker_main_agency_cea_license = self.getOption('{{$broker_main_agency_cea_license}}', 'Main Agent Agency CEA License');
        self.pushOption(self.BROKER_OPTIONS_1, broker_main_agency_cea_license);

        // -----------  Co-Broker  -----------
        let broker_co_name = self.getOption('{{$broker_co_name}}', 'Co-Broker Name');
        self.pushOption(self.BROKER_OPTIONS_1, broker_co_name);

        let broker_co_email = self.getOption('{{$broker_co_email}}', 'Co-Broker Email');
        self.pushOption(self.BROKER_OPTIONS_1, broker_co_email);

        let broker_co_phone = self.getOption('{{$broker_co_phone}}', 'Co-Broker Phone');
        self.pushOption(self.BROKER_OPTIONS_1, broker_co_phone);

        let broker_co_reg_no = self.getOption('{{$broker_co_reg_no}}', 'Co-Broker Reg No');
        self.pushOption(self.BROKER_OPTIONS_1, broker_co_reg_no);

        let broker_co_agency_name = self.getOption('{{$broker_co_agency_name}}', 'Co-Broker Agency Name');
        self.pushOption(self.BROKER_OPTIONS_1, broker_co_agency_name);

        let broker_co_agency_cea_license = self.getOption('{{$broker_co_agency_cea_license}}', 'Co-Broker Agency CEA License');
        self.pushOption(self.BROKER_OPTIONS_1, broker_co_agency_cea_license);
    }

    //-------------------------------------------

    getProperty() {
        const self = this;

        if (!self.data.property_id)
            return;

        self.property = null;
        self.propertyParams = null;

        let url = 'sec/developer/properties/' + self.data.property_id;

        loading(true);
        self.SSHttpService.getAPIRequest(url).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }
            self.property = response.data.property;

            self.getPropertyDocuments();
            self.getPropertyQuestions();
        });
    }

    getPropertyDocuments() {
        const self = this;

        let url = 'sec/developer/properties/' + self.property.id + '/documents';

        loading(true);
        self.SSHttpService.getAPIRequest(url).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            $.each(response.data.property_documents, function (index, document) {
                self.documents.push(document);
            });

            if (self.documents) {
                self.openEditor();
            }
        });
    }

    getPropertyQuestions() {
        const self = this;

        self.propertyQuestions = null;

        let url = 'sec/developer/properties/' + self.property.id + '/questions';

        //loading(true);
        self.SSHttpService.getAPIRequest(url).then(function (response) {
            //loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.propertyQuestions = response.data.property_questions;
        
            // Set buyer options and append questions to each buyer's dropdown
            self.setBuyerOptions();
            self.setAuthorisedOfficerOptions();
        });
    }

    openEditor() {
        const self = this;

        let buyer_document = self.documents.find(x => x.id == self.document_id);

        if (buyer_document && buyer_document.file_uri) {

            let url = 'sec/assets/presigned-url';
            let params = {
                'model': self.ASSET_MODEL_PROPERTY_DOCUMENT,
                'id': buyer_document.id
            };

            loading(true);
            self.SSHttpService.getAPIRequest(url, params).then(function (response) {
                loading(false);
                if (response instanceof Error) {
                    self.SSAlertService.parseAndDisplayError(response);
                    return;
                }

                buyer_document["show_file_url"] = response.data.presigned_url;

                loading(true);
                $.get(buyer_document["show_file_url"], function (data) {
                    loading(false);
                    try {
                        self.prepareEditorData(data);
                        self.initEditorData();
                    } catch (ex) {
                        console.log(ex);
                    }
                });
            });
        } else {
            self.prepareEditorData();
            self.initEditorData();
        }
    }

    prepareEditorData(data) {
        const self = this;

        if (!data) {
            data = '<div class="container">';
            data += '<div style="font-family: Arial, Helvetica, sans-serif; font-size: 16px;"><span>';
            data += 'Add contents here</span></div></div>';
        }

        let _data = $($.parseHTML('<div>' + data + '</div>'));
        let nodes = _data.find('.container');

        self.editor_pages = [];

        for (var index = 0; index < nodes.length; index++) {

            try{
                let custom_class = nodes[index].getAttribute('class');
                let custom_style = nodes[index].getAttribute('style');

                // Remove 'container' class
                if(custom_class){
                    custom_class = custom_class.replace("container", "");
                    custom_class = custom_class.trim();
                }

                if(custom_class == "undefined"){
                    custom_class = "";
                }
                if(custom_style == "undefined"){
                    custom_style = "";
                    custom_style = custom_style.trim();
                }

                if(custom_class || custom_style){
                    let input_hidden = '<input type="hidden" id="document_style" class="'+ custom_class +'" value="'+ custom_style +'">';

                    let node_html = nodes[index].innerHTML;
                    node_html += input_hidden;

                    self.editor_pages[index] = node_html;
                }
                else{
                    self.editor_pages[index] = nodes[index].innerHTML;
                }
            }
            catch(ex){
                self.editor_pages[index] = nodes[index].innerHTML;
                console.log(ex);
            }
        }

        self.editor_current_page = 1;
        self.setTotalPagesOptions();

        // Following line causing console error but functionality is working
        // Reference: https://code.angularjs.org/1.5.8/docs/error/$rootScope/inprog?p0=$apply
        // self.$scope.$apply();

        self.$timeout(function () {
            self.$scope.$apply();
        });
    }

    setTotalPagesOptions(){
        const self = this;

        self.TOTAL_PAGES_OPTIONS = [];

        for(var index = 0; index < self.editor_pages.length; index++){
            self.TOTAL_PAGES_OPTIONS.push({id: index + 1, name: index + 1 });
        }
        
        self.jump_to_page = self.editor_current_page;
    }

    buildListItem(commandName, item) {
        return "<li>" +
            "<a class=\"fr-command\"" +
            "   data-cmd=\"" + commandName + "\"" +
            "   title=\"" + item.title + "\"" +
            // "   data-param1=\"<span style='display:inline-block' class='code-mapping' id='" + item.id + "'>" + item.label + "</span>\"" +
            "   data-param1=\"" + item.code + "\"" +
            ">" + item.title + "</a>" +
            "</li>";
    };

    refreshDropdown(editorInstance, dropdown, placeholders, commandName){
        const self = this;

        let list = dropdown.find('ul.fr-dropdown-list');

        // Remove previous 'innerHtml' if exists
        $(list).html('');
        let listItems = '';

        jQuery.each(placeholders, function (index, _item) {
            listItems += self.buildListItem(commandName, _item);
        });

        $(list).empty().append(listItems);

        if (!editorInstance.selection.inEditor()) {
            // Move cursor position to end.
            editorInstance.selection.setAtEnd(editorInstance.$el.get(0));
            editorInstance.selection.restore();
        }
    }

    initEditorData() {
        const self = this;

        // // Initialize/Re-initialize editor widgets
        FroalaEditor.DefineIcon('close', {NAME: 'remove', SVG_KEY: 'close'});
        FroalaEditor.RegisterCommand('close', {
            title: 'Close',
            focus: false,
            undo: true,
            refreshAfterCallback: true,
            callback: function () {
                // if (new FroalaEditor('div#froala-editor').data('froala.editor')) {
                //     new FroalaEditor('div#froala-editor').destroy();
                // }
                self.redirectBack();
            }
        });

        FroalaEditor.DefineIcon('save', {NAME: 'Save', template: 'text'});
        FroalaEditor.RegisterCommand('save', {
            title: 'Save',
            focus: true,
            undo: true,
            refreshAfterCallback: true,
            callback: function () {

                self.updateCurrentPageContents();
                if(!self.validateMappings()){
                    return;
                }

                let content = '';

                jQuery.each(self.editor_pages, function (index, pageContent) {
                    // content += '<div class="container">' + pageContent + '</div>';

                    try{
                        let raw_html = $.parseHTML('<div>' + pageContent + '</div>');

                        // Remove 'Powered by Froala Editor' water mark
                        $(raw_html).find("p[data-f-id='pbf']").remove();

                        let input_hidden = $(raw_html).find('#document_style');

                        if(input_hidden.length > 0){
                            let _class = $(input_hidden).attr('class');
                            let _style = $(input_hidden).attr('value');

                            $(raw_html).find('#document_style').remove();
                        
                            content += '<div class="container '+ _class +'" style="'+ _style +'">' + $(raw_html).html() + '</div>';
                        }
                        else{
                            content += '<div class="container">' + $(raw_html).html() + '</div>';
                        }
                    }
                    catch(ex){
                        content += '<div class="container">' + pageContent + '</div>';
                        console.log(ex);
                    }
                });

                if (!content) return;

                let proceedWithSave = function () {
                    try {
                        // if ($('div#froala-editor').data('froala.editor')) {
                        //     $('div#froala-editor').froalaEditor('destroy');
                        // }

                        // Unescape special characters
                        let final_content = _.unescape(content);

                        if (final_content) {
                            // Create blob and upload
                            let blob = new Blob([final_content], {type: "text/html;charset=utf-8"});

                            let file_name = 'properties_' + self.property.id + '_documents_' + self.document_id + '.html';

                            let document = self.documents.find(x => x.id == self.document_id);
                            // If document already exist then use previous file name
                            if (document && document.file_uri) {
                                try {
                                    let raw_url = document.file_uri.split('/');
                                    file_name = raw_url[raw_url.length - 1];
                                }
                                catch (ex) {
                                    console.log(ex);
                                }
                            }
                            self.uploadFile(blob, file_name);
                        }

                    } catch (ex) {
                        console.log(ex);
                    }
                };

                // Duplicate ids (eg. Froala's "isPasted" paste artifact) are invalid HTML and make
                // report/PDF generation from this template fail server-side. Warn but allow bypass.
                let duplicate_ids = self.getDuplicateElementIds(content);

                if (Object.keys(duplicate_ids).length > 0) {
                    let duplicates_message = Object.keys(duplicate_ids).map(function (id) {
                        return id + ' (' + duplicate_ids[id] + ' occurrences)';
                    }).join(',\n');

                    // The confirmation modal renders this message with white-space: pre-wrap,
                    // so newlines put each duplicate id on its own line.
                    let message = 'This document has duplicate element IDs:\n' + duplicates_message +
                        '.\nDuplicate IDs can cause reports and PDFs generated from this template to fail. Save anyway?';

                    // Froala's save command runs outside Angular's digest cycle, so the
                    // ng-show/interpolation bindings on the confirmation modal won't update
                    // unless we force a digest via $timeout.
                    self.$timeout(function () {
                        self.SSConfirmationService.getConfirmed(
                            'Duplicate Element IDs',
                            message,
                            self.SSConfirmationService.CANCEL_PROCEED,
                            proceedWithSave
                        );
                    });
                }
                else {
                    proceedWithSave();
                }
            }
        });

        // Custom image upload handling
        // https://stackoverflow.com/questions/6463439/how-to-open-a-file-browse-dialog-using-javascript
        FroalaEditor.DefineIcon('insertCustomImage', {NAME: 'Image', template: 'text'});
        FroalaEditor.RegisterCommand('insertCustomImage', {
            title: 'Insert Image',
            icon: 'insertCustomImage',
            focus: true,
            undo: true,
            refreshAfterCallback: true,

            callback: function (cmd, val) {

                $('#imgupload').on('change', function () {

                    if (!this.files || this.files.length < 1) return;

                    self.uploadedImage = this.files[0];

                    if (this.files.length) {

                        let policyUrl = 'sec/developer/properties/'+ self.data.property_id + '/documents/assets/s3-policy-property-document';

                        loading(true);
                        self.SSAwsService.policyAPIRequest(policyUrl, function (policyObj) {
                            loading(false);

                            if (policyObj instanceof Error) {
                                self.SSAlertService.error("Unable to upload file. Please contact support.");
                                return;
                            }

                            loading(true);
                            self.SSAwsService.upload(self.uploadedImage, policyObj, function (response) {
                                loading(false);
                                if (response instanceof Error) {
                                    self.SSAlertService.parseAndDisplayError(response);
                                    return;
                                }

                                let imageURL = self.SSUtilService.makeAssetUrl(response.config.data.key);
                                self.editor.image.insert(imageURL, null, null, self.editor.image.get());
                            });
                        });
                    }

                }).click();

            },
            // Callback on refresh.
            refresh: function ($btn) {
            },
            // Callback on dropdown show.
            refreshOnShow: function ($btn, $dropdown) {
                this.size.refresh(); // TODO: not working :-(
            }
        });

        FroalaEditor.DefineIcon('insertNewPage', {NAME: 'Page +', template: 'text'});
        FroalaEditor.RegisterCommand('insertNewPage', {
            title: 'Insert New Page',
            icon: 'insertNewPage',
            focus: true,
            undo: true,
            refreshAfterCallback: true,

            callback: function (cmd, val) {

                self.updateCurrentPageContents();

                let newPageContent = '<div><span>';
                    newPageContent += 'Add contents here</span></div>';

                // $('div#froala-editor').froalaEditor('html.set', newPageContent);
                self.editor.html.set(newPageContent);

                self.editor_pages.splice(self.editor_current_page, 0, newPageContent);
                self.editor_current_page++;
                self.setTotalPagesOptions();

                // Following line causing console error but functionality is working
                // Reference: https://code.angularjs.org/1.5.8/docs/error/$rootScope/inprog?p0=$apply
                // self.$scope.$apply();

                self.$timeout(function () {
                    self.$scope.$apply();
                });
            },
            // Callback on refresh.
            refresh: function ($btn) {
            },
            // Callback on dropdown show.
            refreshOnShow: function ($btn, $dropdown) {
                this.size.refresh(); // TODO: not working :-(
            }
        });

        FroalaEditor.DefineIcon('removeCurrentPage', {NAME: 'Page -', template: 'text'});
        FroalaEditor.RegisterCommand('removeCurrentPage', {
            title: 'Remove Current Page',
            icon: 'removeCurrentPage',
            focus: true,
            undo: true,
            refreshAfterCallback: true,

            callback: function (cmd, val) {

                // Don't remove, if there is only one page 
                if (self.editor_pages.length <= 1) {
                    return;
                }

                // Remove current page: array.splice(index, numberOfValues);
                self.editor_pages.splice(self.editor_current_page - 1, 1);

                self.editor_current_page = self.editor_current_page == 1 ? 1 : self.editor_current_page - 1;

                // Display first page
                let content = self.editor_pages[self.editor_current_page - 1];

                self.editor.html.set(content);
                self.setTotalPagesOptions();

                // Following line causing console error but functionality is working
                // Reference: https://code.angularjs.org/1.5.8/docs/error/$rootScope/inprog?p0=$apply
                // self.$scope.$apply();

                self.$timeout(function () {
                    self.$scope.$apply();
                });
            },
            // Callback on refresh.
            refresh: function ($btn) {
            },
            // Callback on dropdown show.
            refreshOnShow: function ($btn, $dropdown) {
                this.size.refresh(); // TODO: not working :-(
            }
        });

        // // Option to view/update page style
        FroalaEditor.DefineIcon('viewUpdateStyle', {NAME: 'Style', template: 'text'});
        FroalaEditor.RegisterCommand('viewUpdateStyle', {
            title: 'View/Update Page Style',
            icon: 'viewUpdateStyle',
            focus: true,
            undo: true,
            refreshAfterCallback: true,

            callback: function (cmd, val) {

                try{
                    let raw_html = $.parseHTML('<div>' + new FroalaEditor('div#froala-editor').html.get(true) + '</div>');
                    // let raw_html = $.parseHTML('<div>' + $('div#froala-editor').froalaEditor('html.get') + '</div>');

                    let input_hidden = $(raw_html).find('#document_style');

                    if(input_hidden.length > 0){
                        let _class = $(input_hidden).attr('class');
                        let _style = $(input_hidden).attr('value');

                        var updated_class = prompt("Class applied on this page.\n(Press Cancel button to remove current value)", _class);
                        var updated_style = prompt("Style(s) applied on this page.\n(Press Cancel button to remove current value)", _style);

                        // If user clicks 'Cancel' on 'prompt' then it will return null
                        self.updatePageStyle(updated_class ? updated_class : '', updated_style ? updated_style : '');

                        // $("#dialog-form").dialog();
                    }
                    else{
                        var updated_class = prompt("No class applied on this page.\n\nEnter class:");
                        var updated_style = prompt("No style(s) applied on this page.\n\nEnter style(s):");
                        self.updatePageStyle(updated_class ? updated_class : '', updated_style ? updated_style : '');
                    }
                }
                catch(ex){
                    console.log(ex);
                }

                // Following line causing console error but functionality is working
                // Reference: https://code.angularjs.org/1.5.8/docs/error/$rootScope/inprog?p0=$apply
                // self.$scope.$apply();

                self.$timeout(function () {
                    self.$scope.$apply();
                });
            },
            // Callback on refresh.
            refresh: function ($btn) {
            },
            // Callback on dropdown show.
            refreshOnShow: function ($btn, $dropdown) {
                this.size.refresh(); // TODO: not working :-(
            }
        });

        // // Option to check mappings added on page(s)
        FroalaEditor.DefineIcon('mappings', {NAME: 'Mappings', template: 'text'});
        FroalaEditor.RegisterCommand('mappings', {
            title: 'View code mappings',
            icon: 'mappings',
            focus: true,
            undo: true,
            refreshAfterCallback: true,

            callback: function (cmd, val) {

                self.updateCurrentPageContents();

                try{
                    var mappings = "";

                    for(var index = 0; index < self.editor_pages.length; index++){

                        mappings += "<strong>------  PAGE " + (index + 1) + "  ------</strong></br></br>";

                        let contents = self.editor_pages[index];

                        // Get the mappings with following format
                        // @{MAPPING}
                        let custom_mappings = self.getRegexResult(contents, /(\@{[^}]+)\}/g, 'custom');

                        // Modified above regex to capture following case
                        // {{$buyer1_gender}</b>}"
                        let generic_mappings = self.getRegexResult(contents, /\{{([^}]+)([A-Z0-9a-z\}].*?)\}/g, 'generic');

                        // Regex to capture this case: {<strong>{$buyer1_gender}}
                        let _special_case = self.getRegexResult(contents, /\{(<(\/?[^>]+)>){([^}]+)([\w\}].*?)\}/g, 'generic');

                        // if both 'generic_mappings' and 'custom_mappings' are false
                        // then condition will be true
                        if(!(generic_mappings || custom_mappings)){
                            mappings += "No mappings on this page</br>";
                        }
                        else{
                            mappings += generic_mappings ? generic_mappings + "</br>" : "";
                            mappings += _special_case ? _special_case + "</br>" : "";
                            mappings += custom_mappings ? custom_mappings + "</br>" : "";
                        }
                        mappings += "</br>";
                    }

                    $("#dialog-contents").empty();
                    $("#dialog-contents").append(mappings);
                    $("#dialog-form").dialog();
                    $("#dialog-form").parent().css({"position": "fixed", "width": "310px", "top": "60px", "left": "665px"});
                }
                catch(ex){
                    console.log(ex);
                }
            },
            // Callback on refresh.
            refresh: function ($btn) {
            },
            // Callback on dropdown show.
            refreshOnShow: function ($btn, $dropdown) {
                this.size.refresh(); // TODO: not working :-(
            }
        });

        // Option to guide user for usage of different options
        FroalaEditor.DefineIcon('help', {NAME: 'Help', template: 'text'});
        FroalaEditor.RegisterCommand('help', {
            title: 'Help',
            icon: 'help',
            focus: true,
            undo: true,
            refreshAfterCallback: true,

            callback: function (cmd, val) {

                try{
                    var help = self.getHelpOptions();

                    $("#dialog-contents").empty();
                    $("#dialog-contents").append(help);
                    $("#dialog-form").dialog({ title: "Help" });
                    $("#dialog-form").parent().css({"position": "fixed", "width": "570px", "top": "60px", "left": "560px"});
                }
                catch(ex){
                    console.log(ex);
                }
            },
            // Callback on refresh.
            refresh: function ($btn) {
            },
            // Callback on dropdown show.
            refreshOnShow: function ($btn, $dropdown) {
                this.size.refresh(); // TODO: not working :-(
            }
        });

        // // Advance Options Menu e.g Date
        FroalaEditor.DefineIcon('advancedOptions', {NAME: 'General', template: 'text'});
        FroalaEditor.RegisterCommand('advancedOptions', {
            title: 'General',
            type: 'dropdown',
            icon: 'advancedOptions',
            focus: true,
            undo: true,
            refreshAfterCallback: true,

            options: {},

            callback: function (cmd, val) {
                try{
                    let raw_html = $.parseHTML(val);
                    if($(raw_html).attr('type') == 'radio' || $(raw_html).attr('type') == 'checkbox'){
                        let name = prompt('Please choose a group name', self.group_name ? self.group_name : '');
                        if(name){
                            self.group_name = name;
                            $(raw_html).attr('name', name);
                            val = $(raw_html).prop('outerHTML').replace(/\"/g, "\'");
                        }
                    }
                }
                catch(ex){
                    console.log(ex);
                }
                this.html.insert(val);
                //this.undo.saveStep();
            },
            // Callback on refresh.
            refresh: function ($btn) {
            },
            // Callback on dropdown show.
            refreshOnShow: function ($btn, $dropdown) {
                let editorInstance = this;

                let list = $dropdown.find('ul.fr-dropdown-list');
                // Remove previous 'innerHtml'
                $(list).html('');
                let listItems = '';
                let placeholders = self.ADVANCED_OPTIONS;

                let commandName = 'advancedOptions';

                jQuery.each(placeholders, function (index, _item) {
                    //Skip for specific entries i.e. PDPA OPTION 1, PDPA OPTION 2
                    let skipIds = ['advance_option_13', 'advance_option_14'];

                    // If _item.type is checkbox/radio then set unique id, name and class
                    try{
                        if((_item.type == 'input' || _item.type == 'textarea' || _item.type == 'checkbox' || _item.type == 'radio')  && !skipIds.includes(_item.id)){

                            let raw_html = $.parseHTML(_item.code);
                            let unique_value = self.getUniqueValue();
                            $(raw_html).attr('id', unique_value);
                            $(raw_html).attr('name', unique_value);

                            if(_item.type == 'checkbox' || _item.type == 'radio'){
                                $(raw_html).attr('class', "checkbox_@{" + unique_value + "}");
                            }
                            else if(_item.type == 'input'){
                                $(raw_html).attr('value', "@{" + unique_value + "}");
                            }
                            else if(_item.type == 'textarea'){
                                $(raw_html).text("@{" + unique_value + "}");
                            }
                            _item.code = $(raw_html).prop('outerHTML').replace(/\"/g, "\'");
                        }
                        else{
                            let raw_html = $.parseHTML(_item.code);
                            _item.code = $(raw_html).prop('outerHTML').replace(/\"/g, "\'");
                        }
                    }
                    catch(ex){
                        console.log(ex);
                    }
                    listItems += self.buildListItem(commandName, _item);
                });

                $(list).empty().append(listItems);

                if (!editorInstance.selection.inEditor()) {
                    // Move cursor position to end.
                    editorInstance.selection.setAtEnd(editorInstance.$el.get(0));
                    editorInstance.selection.restore();
                }
            }
        });

        // // Insert Property Values Menu
        FroalaEditor.DefineIcon('insertPropertyOptions', {NAME: 'Property', template: 'text'});
        FroalaEditor.RegisterCommand('insertPropertyOptions', {
            title: 'Property',
            type: 'dropdown',
            icon: 'insertPropertyOptions',
            focus: true,
            undo: true,
            refreshAfterCallback: true,

            options: {},

            callback: function (cmd, val) {
                this.html.insert(val);
                //this.undo.saveStep();
            },
            // Callback on refresh.
            refresh: function ($btn) {
            },
            // Callback on dropdown show.
            refreshOnShow: function ($btn, $dropdown) {
                let editorInstance = this;

                self.refreshDropdown(editorInstance, $dropdown, self.PROPERTY_OPTIONS, 'insertPropertyOptions');
            }
        });

        // // Unit Options Menu
        FroalaEditor.DefineIcon('insertUnitOptions', {NAME: 'Unit', template: 'text'});
        FroalaEditor.RegisterCommand('insertUnitOptions', {
            title: 'Unit',
            type: 'dropdown',
            icon: 'insertUnitOptions',
            focus: true,
            undo: true,
            refreshAfterCallback: true,

            options: {},

            callback: function (cmd, val) {
                this.html.insert(val);
                //this.undo.saveStep();
            },
            refresh: function ($btn) {
            },
            refreshOnShow: function ($btn, $dropdown) {
                let editorInstance = this;

                self.refreshDropdown(editorInstance, $dropdown, self.UNIT_OPTIONS, 'insertUnitOptions');
            }
        });

        // Authorised Buyer Officer Options Menu
        FroalaEditor.DefineIcon('insertAuthorisedOfficerOptions', {NAME: 'Authorised Officer', template: 'text'});
        FroalaEditor.RegisterCommand('insertAuthorisedOfficerOptions', {
            title: 'Authorised Officer',
            type: 'dropdown',
            icon: 'insertAuthorisedOfficerOptions',
            focus: true,
            undo: true,
            refreshAfterCallback: true,

            options: {},

            callback: function (cmd, val) {
                this.html.insert(val);
                //this.undo.saveStep();
            },
            refresh: function ($btn) {
            },
            refreshOnShow: function ($btn, $dropdown) {
                let editorInstance = this;

                self.refreshDropdown(editorInstance, $dropdown, self.AUTHORISED_OFFICER_OPTIONS, 'insertAuthorisedOfficerOptions');
            }
        });

        FroalaEditor.DefineIcon('insertNonBuyerPayee1Options', {NAME: 'NonBuyerPayee1', template: 'text'});
        FroalaEditor.RegisterCommand('insertNonBuyerPayee1Options', {
            title: 'Non Buyer Payee 1',
            type: 'dropdown',
            icon: 'insertNonBuyerPayee1Options',
            focus: true,
            undo: true,
            refreshAfterCallback: true,

            options: {},

            callback: function (cmd, val) {
                this.html.insert(val);
                //this.undo.saveStep();
            },
            refresh: function ($btn) {
            },
            refreshOnShow: function ($btn, $dropdown) {
                let editorInstance = this;

                self.refreshDropdown(editorInstance, $dropdown, self.NON_BUYER_PAYEE1_OPTIONS, 'insertNonBuyerPayee1Options');
            }
        });

        FroalaEditor.DefineIcon('insertNonBuyerPayee2Options', {NAME: 'NonBuyerPayee2', template: 'text'});
        FroalaEditor.RegisterCommand('insertNonBuyerPayee2Options', {
            title: 'Non Buyer Payee 2',
            type: 'dropdown',
            icon: 'insertNonBuyerPayee2Options',
            focus: true,
            undo: true,
            refreshAfterCallback: true,

            options: {},

            callback: function (cmd, val) {
                this.html.insert(val);
                //this.undo.saveStep();
            },
            refresh: function ($btn) {
            },
            refreshOnShow: function ($btn, $dropdown) {
                let editorInstance = this;

                self.refreshDropdown(editorInstance, $dropdown, self.NON_BUYER_PAYEE2_OPTIONS, 'insertNonBuyerPayee2Options');
            }
        });

        FroalaEditor.DefineIcon('insertNonBuyerPayee3Options', {NAME: 'NonBuyerPayee3', template: 'text'});
        FroalaEditor.RegisterCommand('insertNonBuyerPayee3Options', {
            title: 'Non Buyer Payee 3',
            type: 'dropdown',
            icon: 'insertNonBuyerPayee3Options',
            focus: true,
            undo: true,
            refreshAfterCallback: true,

            options: {},

            callback: function (cmd, val) {
                this.html.insert(val);
                //this.undo.saveStep();
            },
            refresh: function ($btn) {
            },
            refreshOnShow: function ($btn, $dropdown) {
                let editorInstance = this;

                self.refreshDropdown(editorInstance, $dropdown, self.NON_BUYER_PAYEE3_OPTIONS, 'insertNonBuyerPayee3Options');
            }
        });

        FroalaEditor.DefineIcon('insertNonBuyerPayee4Options', {NAME: 'NonBuyerPayee4', template: 'text'});
        FroalaEditor.RegisterCommand('insertNonBuyerPayee4Options', {
            title: 'Non Buyer Payee 4',
            type: 'dropdown',
            icon: 'insertNonBuyerPayee4Options',
            focus: true,
            undo: true,
            refreshAfterCallback: true,

            options: {},

            callback: function (cmd, val) {
                this.html.insert(val);
                //this.undo.saveStep();
            },
            refresh: function ($btn) {
            },
            refreshOnShow: function ($btn, $dropdown) {
                let editorInstance = this;

                self.refreshDropdown(editorInstance, $dropdown, self.NON_BUYER_PAYEE4_OPTIONS, 'insertNonBuyerPayee4Options');
            }
        });

        FroalaEditor.DefineIcon('insertNonBuyerPayee5Options', {NAME: 'NonBuyerPayee5', template: 'text'});
        FroalaEditor.RegisterCommand('insertNonBuyerPayee5Options', {
            title: 'Non Buyer Payee 5',
            type: 'dropdown',
            icon: 'insertNonBuyerPayee5Options',
            focus: true,
            undo: true,
            refreshAfterCallback: true,

            options: {},

            callback: function (cmd, val) {
                this.html.insert(val);
                //this.undo.saveStep();
            },
            refresh: function ($btn) {
            },
            refreshOnShow: function ($btn, $dropdown) {
                let editorInstance = this;

                self.refreshDropdown(editorInstance, $dropdown, self.NON_BUYER_PAYEE5_OPTIONS, 'insertNonBuyerPayee5Options');
            }
        });

        FroalaEditor.DefineIcon('insertNonBuyerPayee6Options', {NAME: 'NonBuyerPayee6', template: 'text'});
        FroalaEditor.RegisterCommand('insertNonBuyerPayee6Options', {
            title: 'Non Buyer Payee 6',
            type: 'dropdown',
            icon: 'insertNonBuyerPayee6Options',
            focus: true,
            undo: true,
            refreshAfterCallback: true,

            options: {},

            callback: function (cmd, val) {
                this.html.insert(val);
                //this.undo.saveStep();
            },
            refresh: function ($btn) {
            },
            refreshOnShow: function ($btn, $dropdown) {
                let editorInstance = this;

                self.refreshDropdown(editorInstance, $dropdown, self.NON_BUYER_PAYEE6_OPTIONS, 'insertNonBuyerPayee6Options');
            }
        });

        // Witness Options Menu
        FroalaEditor.DefineIcon('insertWitness1Options', {NAME: 'Witness1', template: 'text'});
        FroalaEditor.RegisterCommand('insertWitness1Options', {
            title: 'Witness 1',
            type: 'dropdown',
            icon: 'insertWitness1Options',
            focus: true,
            undo: true,
            refreshAfterCallback: true,

            options: {},

            callback: function (cmd, val) {
                this.html.insert(val);
                //this.undo.saveStep();
            },
            refresh: function ($btn) {
            },
            refreshOnShow: function ($btn, $dropdown) {
                let editorInstance = this;

                self.refreshDropdown(editorInstance, $dropdown, self.WITNESS1_OPTIONS, 'insertWitness1Options');
            }
        });

        FroalaEditor.DefineIcon('insertWitness2Options', {NAME: 'Witness2', template: 'text'});
        FroalaEditor.RegisterCommand('insertWitness2Options', {
            title: 'Witness 2',
            type: 'dropdown',
            icon: 'insertWitness2Options',
            focus: true,
            undo: true,
            refreshAfterCallback: true,

            options: {},

            callback: function (cmd, val) {
                this.html.insert(val);
                //this.undo.saveStep();
            },
            refresh: function ($btn) {
            },
            refreshOnShow: function ($btn, $dropdown) {
                let editorInstance = this;

                self.refreshDropdown(editorInstance, $dropdown, self.WITNESS2_OPTIONS, 'insertWitness2Options');
            }
        });

        FroalaEditor.DefineIcon('insertWitness3Options', {NAME: 'Witness3', template: 'text'});
        FroalaEditor.RegisterCommand('insertWitness3Options', {
            title: 'Witness 3',
            type: 'dropdown',
            icon: 'insertWitness3Options',
            focus: true,
            undo: true,
            refreshAfterCallback: true,

            options: {},

            callback: function (cmd, val) {
                this.html.insert(val);
                //this.undo.saveStep();
            },
            refresh: function ($btn) {
            },
            refreshOnShow: function ($btn, $dropdown) {
                let editorInstance = this;

                self.refreshDropdown(editorInstance, $dropdown, self.WITNESS3_OPTIONS, 'insertWitness3Options');
            }
        });

        FroalaEditor.DefineIcon('insertWitness4Options', {NAME: 'Witness4', template: 'text'});
        FroalaEditor.RegisterCommand('insertWitness4Options', {
            title: 'Witness 4',
            type: 'dropdown',
            icon: 'insertWitness4Options',
            focus: true,
            undo: true,
            refreshAfterCallback: true,

            options: {},

            callback: function (cmd, val) {
                this.html.insert(val);
                //this.undo.saveStep();
            },
            refresh: function ($btn) {
            },
            refreshOnShow: function ($btn, $dropdown) {
                let editorInstance = this;

                self.refreshDropdown(editorInstance, $dropdown, self.WITNESS4_OPTIONS, 'insertWitness4Options');
            }
        });

        // Buyer Options Menu
        FroalaEditor.DefineIcon('insertBuyerOptions', {NAME: 'Buyer', template: 'text'});
        FroalaEditor.RegisterCommand('insertBuyerOptions', {
            title: 'Buyer',
            type: 'dropdown',
            icon: 'insertBuyerOptions',
            focus: true,
            undo: true,
            refreshAfterCallback: true,

            options: {},

            callback: function (cmd, val) {
                this.html.insert(val);
                //this.undo.saveStep();
            },
            refresh: function ($btn) {
            },
            refreshOnShow: function ($btn, $dropdown) {
                let editorInstance = this;

                self.refreshDropdown(editorInstance, $dropdown, self.BUYER_OPTIONS, 'insertBuyerOptions');
            }
        });

        // // Buyer 1 Options Menu
        FroalaEditor.DefineIcon('insertBuyer1Options', {NAME: 'Buyer1', template: 'text'});
        FroalaEditor.RegisterCommand('insertBuyer1Options', {
            title: 'Buyer1',
            type: 'dropdown',
            icon: 'insertBuyer1Options',
            focus: true,
            undo: true,
            refreshAfterCallback: true,

            options: {},

            callback: function (cmd, val) {
                this.html.insert(val);
                //this.undo.saveStep();
            },
            refresh: function ($btn) {
            },
            refreshOnShow: function ($btn, $dropdown) {
                let editorInstance = this;

                self.refreshDropdown(editorInstance, $dropdown, self.BUYER1_OPTIONS, 'insertBuyer1Options');
            }
        });

        // // Buyer 2 Options Menu
        FroalaEditor.DefineIcon('insertBuyer2Options', {NAME: 'Buyer2', template: 'text'});
        FroalaEditor.RegisterCommand('insertBuyer2Options', {
            title: 'Buyer2',
            type: 'dropdown',
            icon: 'insertBuyer2Options',
            focus: true,
            undo: true,
            refreshAfterCallback: true,

            options: {},

            callback: function (cmd, val) {
                this.html.insert(val);
                //this.undo.saveStep();
            },
            refresh: function ($btn) {
            },
            refreshOnShow: function ($btn, $dropdown) {
                let editorInstance = this;

                self.refreshDropdown(editorInstance, $dropdown, self.BUYER2_OPTIONS, 'insertBuyer2Options');
            }
        });

        // // Buyer 3 Options Menu
        FroalaEditor.DefineIcon('insertBuyer3Options', {NAME: 'Buyer3', template: 'text'});
        FroalaEditor.RegisterCommand('insertBuyer3Options', {
            title: 'Buyer3',
            type: 'dropdown',
            icon: 'insertBuyer3Options',
            focus: true,
            undo: true,
            refreshAfterCallback: true,

            options: {},

            callback: function (cmd, val) {
                this.html.insert(val);
                //this.undo.saveStep();
            },
            refresh: function ($btn) {
            },
            refreshOnShow: function ($btn, $dropdown) {
                let editorInstance = this;

                self.refreshDropdown(editorInstance, $dropdown, self.BUYER3_OPTIONS, 'insertBuyer3Options');
            }
        });

        // // Buyer 4 Options Menu
        FroalaEditor.DefineIcon('insertBuyer4Options', {NAME: 'Buyer4', template: 'text'});
        FroalaEditor.RegisterCommand('insertBuyer4Options', {
            title: 'Buyer4',
            type: 'dropdown',
            icon: 'insertBuyer4Options',
            focus: true,
            undo: true,
            refreshAfterCallback: true,

            options: {},

            callback: function (cmd, val) {
                this.html.insert(val);
                //this.undo.saveStep();
            },
            refresh: function ($btn) {
            },
            refreshOnShow: function ($btn, $dropdown) {
                let editorInstance = this;

                self.refreshDropdown(editorInstance, $dropdown, self.BUYER4_OPTIONS, 'insertBuyer4Options');
            }
        });

        // Beneficiary 1 Options Menu
        FroalaEditor.DefineIcon('insertBeneficiary1Options', {NAME: 'Beneficiary1', template: 'text'});
        FroalaEditor.RegisterCommand('insertBeneficiary1Options', {
            title: 'Beneficiary1',
            type: 'dropdown',
            icon: 'insertBeneficiary1Options',
            focus: true,
            undo: true,
            refreshAfterCallback: true,

            options: {},

            callback: function (cmd, val) {
                this.html.insert(val);
                //this.undo.saveStep();
            },
            refresh: function ($btn) {
            },
            refreshOnShow: function ($btn, $dropdown) {
                let editorInstance = this;

                self.refreshDropdown(editorInstance, $dropdown, self.BENEFICIARY1_OPTIONS, 'insertBeneficiary1Options');
            }
        });

        // Beneficiary 2 Options Menu
        FroalaEditor.DefineIcon('insertBeneficiary2Options', {NAME: 'Beneficiary2', template: 'text'});
        FroalaEditor.RegisterCommand('insertBeneficiary2Options', {
            title: 'Beneficiary2',
            type: 'dropdown',
            icon: 'insertBeneficiary2Options',
            focus: true,
            undo: true,
            refreshAfterCallback: true,

            options: {},

            callback: function (cmd, val) {
                this.html.insert(val);
                //this.undo.saveStep();
            },
            refresh: function ($btn) {
            },
            refreshOnShow: function ($btn, $dropdown) {
                let editorInstance = this;

                self.refreshDropdown(editorInstance, $dropdown, self.BENEFICIARY2_OPTIONS, 'insertBeneficiary2Options');
            }
        });

        // Signatures Menu
        FroalaEditor.DefineIcon('insertSignatures', {NAME: 'Signature', template: 'text'});
        FroalaEditor.RegisterCommand('insertSignatures', {
            title: 'Signatures',
            type: 'dropdown',
            icon: 'insertSignatures',
            focus: true,
            undo: true,
            refreshAfterCallback: true,

            options: {},

            callback: function (cmd, val) {
                this.html.insert(val);
                //this.undo.saveStep();
            },
            refresh: function ($btn) {
            },
            refreshOnShow: function ($btn, $dropdown) {
                let editorInstance = this;

                self.refreshDropdown(editorInstance, $dropdown, self.SIGNATURE_OPTIONS, 'insertSignatures');
            }
        });

        // // Payment Options Menu
        FroalaEditor.DefineIcon('insertPaymentOptions', {NAME: 'Payments', template: 'text'});
        FroalaEditor.RegisterCommand('insertPaymentOptions', {
            title: 'Payments',
            type: 'dropdown',
            icon: 'insertPaymentOptions',
            focus: true,
            undo: true,
            refreshAfterCallback: true,

            options: {},

            callback: function (cmd, val) {
                this.html.insert(val);
            },
            refresh: function ($btn) {
            },
            refreshOnShow: function ($btn, $dropdown) {
                let editorInstance = this;

                self.refreshDropdown(editorInstance, $dropdown, self.PAYMENT_OPTIONS, 'insertPaymentOptions');
            }
        });

        // // Lawyer Options Menu
        FroalaEditor.DefineIcon('insertLawyerOptions', {NAME: 'Lawyer', template: 'text'});
        FroalaEditor.RegisterCommand('insertLawyerOptions', {
            title: 'Lawyer',
            type: 'dropdown',
            icon: 'insertLawyerOptions',
            focus: true,
            undo: true,
            refreshAfterCallback: true,

            options: {},

            callback: function (cmd, val) {
                this.html.insert(val);
            },
            refresh: function ($btn) {
            },
            refreshOnShow: function ($btn, $dropdown) {
                let editorInstance = this;

                self.refreshDropdown(editorInstance, $dropdown, self.LAWYER_OPTIONS, 'insertLawyerOptions');
            }
        });

        // // Broker Options Menu
        FroalaEditor.DefineIcon('insertBrokerOptions', {NAME: 'Agents', template: 'text'});
        FroalaEditor.RegisterCommand('insertBrokerOptions', {
            title: 'Agents',
            type: 'dropdown',
            icon: 'insertBrokerOptions',
            focus: true,
            undo: true,
            refreshAfterCallback: true,

            options: {},

            callback: function (cmd, val) {
                this.html.insert(val);
            },
            refresh: function ($btn) {
            },
            refreshOnShow: function ($btn, $dropdown) {
                let editorInstance = this;

                self.refreshDropdown(editorInstance, $dropdown, self.BROKER_OPTIONS, 'insertBrokerOptions');
            }
        });

        // // Broker Options Menu 1
        FroalaEditor.DefineIcon('insertBrokerOptions1', {NAME: 'Agents1', template: 'text'});
        FroalaEditor.RegisterCommand('insertBrokerOptions1', {
            title: 'Agents1',
            type: 'dropdown',
            icon: 'insertBrokerOptions1',
            focus: true,
            undo: true,
            refreshAfterCallback: true,
            options: {},

            callback: function (cmd, val) {
                this.html.insert(val);
            },
            refresh: function ($btn) {
            },
            refreshOnShow: function ($btn, $dropdown) {
                let editorInstance = this;

                self.refreshDropdown(editorInstance, $dropdown, self.BROKER_OPTIONS_1, 'insertBrokerOptions1');
            }
        });

        // // Reissue Options
        FroalaEditor.DefineIcon('reissueOptions', {NAME: 'Reissue', template: 'text'});
        FroalaEditor.RegisterCommand('reissueOptions', {
            title: 'Reissue',
            type: 'dropdown',
            icon: 'reissueOptions',
            focus: true,
            undo: true,
            refreshAfterCallback: true,

            options: {},

            callback: function (cmd, val) {
                this.html.insert(val);
            },
            refresh: function ($btn) {
            },
            refreshOnShow: function ($btn, $dropdown) {
                let editorInstance = this;

                self.refreshDropdown(editorInstance, $dropdown, self.REISSUE_OPTIONS, 'reissueOptions');
            }
        });

        // EOI Options
        FroalaEditor.DefineIcon('eoiOptions', {NAME: 'EOI', template: 'text'});
        FroalaEditor.RegisterCommand('eoiOptions', {
            title: 'EOI',
            type: 'dropdown',
            icon: 'eoiOptions',
            focus: true,
            undo: true,
            refreshAfterCallback: true,

            options: {},

            callback: function (cmd, val) {
                this.html.insert(val);
            },
            refresh: function ($btn) {
            },
            refreshOnShow: function ($btn, $dropdown) {
                let editorInstance = this;

                self.refreshDropdown(editorInstance, $dropdown, self.EOI_OPTIONS, 'eoiOptions');
            }
        });

        // Current User Options
        FroalaEditor.DefineIcon('currentUserOptions', {NAME: 'Current User', template: 'text'});
        FroalaEditor.RegisterCommand('currentUserOptions', {
            title: 'Current User',
            type: 'dropdown',
            icon: 'currentUserOptions',
            focus: true,
            undo: true,
            refreshAfterCallback: true,

            options: {},

            callback: function (cmd, val) {
                this.html.insert(val);
            },
            refresh: function ($btn) {
            },
            refreshOnShow: function ($btn, $dropdown) {
                let editorInstance = this;

                self.refreshDropdown(editorInstance, $dropdown, self.CURRENT_USER_OPTIONS, 'currentUserOptions');
            }
        });

         var buttons = [
            ['paragraphFormat', 'fontFamily', 'fontSize', 'bold', 'italic', 'underline', 'strikeThrough',
            '|', 'subscript', 'superscript', 'color',
            '|', 'paragraphStyle', 'inlineStyle', 'align',
            '|', 'formatOL', 'formatUL', 'outdent', 'indent', 'selectAll',
            '|', 'insertHR', 'clearFormatting',
            '|', 'insertLink', 'insertTable', '|', 'insertCustomImage',
            '-', 'html',
            '|', 'undo', 'redo',
            '|', 'save', 'fullscreen', 'close', '|', 'viewUpdateStyle', '|', 'mappings', 
            '|', 'insertNewPage', '|', 'removeCurrentPage', 
            '|', 'help', '|', 'insertAuthorisedOfficerOptions',
            '-', 'advancedOptions', '|', 'insertPropertyOptions', '|', 'insertUnitOptions',
            '|', 'insertBuyerOptions', 'insertBuyer1Options', 'insertBuyer2Options', 'insertBuyer3Options', 'insertBuyer4Options', 
            '|', 'insertSignatures', '|', 'insertLawyerOptions', '-', 
            '|', 'insertPaymentOptions', 
            '|', 'insertBrokerOptions', '|', 'insertBrokerOptions1', 
            '|', 'reissueOptions', '|', 'eoiOptions', '|', 'currentUserOptions', 
            '|', 'insertBeneficiary1Options', 'insertBeneficiary2Options', '-',
            '|', 'insertNonBuyerPayee1Options', 'insertNonBuyerPayee2Options', 'insertNonBuyerPayee3Options', 
            'insertNonBuyerPayee4Options', 'insertNonBuyerPayee5Options', 'insertNonBuyerPayee6Options',
            'insertWitness1Options', 'insertWitness2Options', 'insertWitness3Options', 'insertWitness4Options']
        ];

        // Init Froala Editor
        self.editor = new FroalaEditor('div#froala-editor', {
            // Add the custom buttons in the toolbarButtons list, after the separator.
            key: self.EDITOR_API_KEY,
            //width: 2480,
            //height: 3508,
            charCounterCount: false,
            placeholderText: '',
            //enter: $.FroalaEditor.ENTER_BR,
            iframe: true,
            fontSize: ['8', '9', '10', '11', '12', '14', '16', '18', '24', '30', '36', '48', '60', '72', '96'],
            // fontSizeDefaultSelection: '16',
            // fontFamilyDefaultSelection: 'Arial',

            toolbarButtons: buttons,
            toolbarButtonsMD: buttons,
            toolbarButtonsSM: buttons,
            toolbarButtonsXS: buttons,

            paragraphStyles: {

                'display_{{$is_individual_purchase}}': 'Is Individual Purchase',
                'display_{{$is_corporate_purchase}}': 'Is Corporate Purchase',
                
                ' ': '---------------------',

                'display_{{$buyer1_exists}}': 'Buyer1 Exists',
                'display_{{$buyer2_exists}}': 'Buyer2 Exists',
                'display_{{$buyer3_exists}}': 'Buyer3 Exists',
                'display_{{$buyer4_exists}}': 'Buyer4 Exists',

                '': '---------------------',

                'display_{{$witness1_exists}}': 'Witness1 Exists',
                'display_{{$witness2_exists}}': 'Witness2 Exists',
                'display_{{$witness3_exists}}': 'Witness3 Exists',
                'display_{{$witness4_exists}}': 'Witness4 Exists',

                'display_{{$buyer_is_individual}}': 'Is Buyer Individual',
                'display_{{$buyer_is_company}}': 'Is Buyer Company',

                'display_{{$buyer1_is_individual}}': 'Is Buyer1 Individual',
                'display_{{$buyer1_is_company}}': 'Is Buyer1 Company',

                'display_{{$buyer2_is_individual}}': 'Is Buyer2 Individual',
                'display_{{$buyer2_is_company}}': 'Is Buyer2 Company',

                'display_{{$buyer3_is_individual}}': 'Is Buyer3 Individual',
                'display_{{$buyer3_is_company}}': 'Is Buyer3 Company',

                'display_{{$buyer4_is_individual}}': 'Is Buyer4 Individual',
                'display_{{$buyer4_is_company}}': 'Is Buyer4 Company',

                '  ': '---------------------',
                
                'display_{{$beneficiary1_exists}}': 'Beneficiary1 Exists',
                'display_{{$beneficiary2_exists}}': 'Beneficiary2 Exists',

                '   ': '---------------------',
                
                'display_{{$payment_instrument1_exists}}': 'Payment Instrument1 Exists',
                'display_{{$payment_instrument2_exists}}': 'Payment Instrument2 Exists',
                'display_{{$payment_instrument3_exists}}': 'Payment Instrument3 Exists',
            },

            fontFamilySelection: true,
            fontSizeSelection: true,
            paragraphFormatSelection: true,
            htmlAllowedTags: ['a', 'abbr', 'address', 'area', 'article', 'aside', 'audio', 'b', 'base', 'bdi', 'bdo', 'blockquote', 'br', 'button', 'canvas', 'caption', 'cite', 'code', 'col', 'colgroup', 'datalist', 'dd', 'del', 'details', 'dfn', 'dialog', 'div', 'dl', 'dt', 'em', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'header', 'hgroup', 'hr', 'i', 'iframe', 'img', 'input', 'ins', 'kbd', 'keygen', 'label', 'legend', 'li', 'link', 'main', 'map', 'mark', 'menu', 'menuitem', 'meter', 'nav', 'noscript', 'object', 'ol', 'optgroup', 'option', 'output', 'p', 'param', 'pre', 'progress', 'queue', 'rp', 'rt', 'ruby', 's', 'samp', 'script', 'style', 'section', 'select', 'small', 'source', 'span', 'strike', 'strong', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'textarea', 'tfoot', 'th', 'thead', 'time', 'title', 'tr', 'track', 'u', 'ul', 'var', 'video', 'wbr'],
            htmlRemoveTags: [],

        }, function(){

            // BUILT-IN IMAGE UPLOAD IS NOT WORKING: https://showsuite.atlassian.net/browse/WEB-2307
            // self.editor.html.set(self.editor_pages[self.editor_current_page - 1]);

            // // S3 image handling
            // self.editor.events.on('image.beforeUpload', function (files) {

            //     self.uploadedImage = files[0];

            //     if (files.length) {

            //         let policyUrl = 'sec/developer/properties/'+ self.data.property_id + '/documents/assets/s3-policy-property-document';

            //         loading(true);
            //         self.SSAwsService.policyAPIRequest(policyUrl, function (policyObj) {
            //             loading(false);

            //             if (policyObj instanceof Error) {
            //                 self.SSAlertService.error("Unable to upload file. Please contact support.");
            //                 return;
            //             }

            //             loading(true);
            //             self.SSAwsService.upload(self.uploadedImage, policyObj, function (response) {
            //                 loading(false);
            //                 if (response instanceof Error) {
            //                     self.SSAlertService.parseAndDisplayError(response);
            //                     return;
            //                 }

            //                 let imageURL = self.SSUtilService.makeAssetUrl(response.config.data.key);
            //                 self.editor.image.insert(imageURL, null, null, self.editor.image.get());
            //             });
            //         });
            //     }

            //     self.editor.popups.hideAll();

            //     // Stop default upload chain.
            //     return false;
            // });

            try{
                let text = $('.fr-wrapper').find('div:first-child').text();
                if (text && text.startsWith('Unlicensed')) {
                    $('.fr-wrapper').find('div:first-child>a').css('background', 'lightgray');
                }
                // Hide 'Powered by Froala' text
                if($('a#fr-logo').text().startsWith('Powered by')){
                    $('a#fr-logo').css({'display': 'none'});
                }
            }
            catch(ex){
                console.log(ex);
            }

        });

        // Image handling
        // If image is uploaded then convert it to base64 and insert base64 string in place
        //froalaEditor.on('froalaEditor.image.beforeUpload', function (e, editor, files) {
        //    if (files.length) {
        //        // Create a File Reader.
        //        let reader = new FileReader();
        //
        //        // Set the reader to insert images when they are loaded.
        //        reader.onload = function (e) {
        //            let result = e.target.result;
        //            editor.image.insert(result, null, null, editor.image.get());
        //        };
        //
        //        // Read image as base64.
        //        reader.readAsDataURL(files[0]);
        //    }
        //
        //    editor.popups.hideAll();
        //
        //    // Stop default upload chain.
        //    return false;
        //});

        // Following line causing console error but functionality is working
        // Reference: https://code.angularjs.org/1.5.8/docs/error/$rootScope/inprog?p0=$apply
        // self.$scope.$apply();

        self.$timeout(function () {
            self.editor.html.set(self.editor_pages[0]);
            self.$scope.$apply();
        });
    }

    getRegexResult(str, regex, type = null){
        const self = this;

        if(!str || !regex){
            return;
        }

        let result = str.match(regex);

        // generic_mapping must have following pattern: 
        // {{ mapping }} OR {{!! mapping !!}}

        // custom_mapping must have following pattern: 
        // @{ mapping }

        if(result){
            var color = 'red';

            // for(var index = 0; index < result.length; index++){
            //     if(type == 'generic'){
            //         if(result[index].startsWith('{{') && result[index].endsWith('}}')){
            //             result[index] = "<span>"+ result[index] +"</span>";
            //         }
            //         else if(result[index].startsWith('{{!!') && result[index].endsWith('!!}}')){
            //             result[index] = "<span>"+ result[index] +"</span>";
            //         }
            //         else{
            //             result[index] = '<span style="color:'+ color +'">'+ result[index] +"</span>";
            //         }
            //     }
            //     else if(type == 'custom'){
            //         if(result[index].startsWith('@{') && result[index].endsWith('}')){
            //             result[index] = "<span>"+ result[index] +"</span>";
            //         }
            //         else{
            //             result[index] = '<span style="color:'+ color +'">'+ result[index] +"</span>";
            //         }
            //     }
            // }

            result = result.join('__BREAK__');
            result = result.replace(/</g, "&lt");
            result = result.replace(/>/g, "&gt");
            result = result.replace(/__BREAK__/g, "</br>");
        }

        return result;
    }

    getHelpOptions(){
        const self = this;

        let options = "<div>";

        options += "<strong> 1. Style </strong>";
        options += "<p> You can add/remove style or css class from current page. </p>";

        options += "<strong> 2. Mappings </strong>";
        options += "<p> You can view the mappings added on all pages. </p>";

        return options += "</div>";
    }

    editorBackPage() {
        const self = this;

        if (self.editor_current_page == 1) {
            return;
        }

        self.updateCurrentPageContents();
        self.editor_current_page -= 1;
        self.jump_to_page = self.editor_current_page;
        self.editor.html.set(self.editor_pages[self.editor_current_page - 1]);
    }

    editorNextPage() {
        const self = this;

        if (self.editor_current_page == self.editor_pages.length) {
            return;
        }

        self.updateCurrentPageContents();
        self.editor_current_page += 1;
        self.jump_to_page = self.editor_current_page;
        self.editor.html.set(self.editor_pages[self.editor_current_page - 1]);
    }

    gotoPage(pageNumber){
        const self = this;

        if(!pageNumber){
            return;
        }

        self.updateCurrentPageContents();
        self.editor_current_page = pageNumber;
        self.editor.html.set(self.editor_pages[self.editor_current_page - 1]);
    }

    updateCurrentPageContents() {
        const self = this;

        let content = new FroalaEditor('div#froala-editor').html.get(true);
        if (content) {
            self.editor_pages[self.editor_current_page - 1] = content;
        }
    }

    validateMappings(){
        const self = this;

        let flage = true;

        try{
            var mappings = "";
            var result = null;

            for(var index = 0; index < self.editor_pages.length; index++){

                let contents = self.editor_pages[index];
                let mistakes = [];
                let _mistakes = '';

                // Get the mappings with following format
                // @{MAPPING}
                result = contents.match(/(\@{[^}]+)\}/g);
                if(result){
                    for(var i = 0; i < result.length; i++){
                        if(!(result[i].startsWith('@{') && result[i].endsWith('}'))){
                            mistakes.push(result[i]);
                            flage = false;
                        }
                    }
                }

                // Modified above regex to capture following case
                // {{$buyer1_gender}</b>}"
                result = contents.match(/\{{([^}]+)([A-Z0-9a-z\}].*?)\}/g);
                if(result){
                    for(var j = 0; j < result.length; j++){
                        if(!((result[j].startsWith('{{') || result[j].startsWith('{{!!')) 
                            && (result[j].endsWith('}}') || result[j].endsWith('!!}}')))){
                            
                            mistakes.push(result[j]);
                            flage = false;
                        }
                    }
                }

                // Regex to capture this case: {<strong>{$buyer1_gender}}
                result = contents.match(/\{(<(\/?[^>]+)>){([^}]+)([\w\}].*?)\}/g);
                if(result){
                    for(var k = 0; k < result.length; k++){
                        if(!(result[k].startsWith('{{') && result[k].endsWith('}}'))){
                            mistakes.push(result[k]);
                            flage = false;
                        }
                    }
                }

                if(mistakes && mistakes.length > 0){
                    mappings += "<strong>------  PAGE " + (index + 1) + "  ------</strong></br></br>";
                    
                    _mistakes = mistakes.join('__BREAK__');
                    _mistakes = _mistakes.replace(/</g, "&lt");
                    _mistakes = _mistakes.replace(/>/g, "&gt");
                    _mistakes = _mistakes.replace(/__BREAK__/g, "</br>");
                    
                    mappings += _mistakes +"</br></br>";
                }
            }

            if(flage == false){

                let error = "<strong style='color: red'> Some mappigs are not correct. </strong></br>";
                error += "<strong style='color: red'>Please check the mappings and try again. </strong></br></br>"
                
                $("#dialog-contents").empty();
                $("#dialog-contents").append(error + mappings);
                $("#dialog-form").dialog();
                $("#dialog-form").parent().css({"position": "fixed", "width": "390px", "top": "60px", "left": "665px"});
            }
        }
        catch(ex){
            console.log(ex);
        }

        return flage;
    }

    // Returns a map of {id: occurrenceCount} for element ids that appear more than once
    // in the given HTML. #document_style is an editor-injected hidden input that is
    // already stripped from the assembled save content, but is excluded here defensively.
    getDuplicateElementIds(html){
        const self = this;

        let counts = {};

        try{
            let raw_html = $.parseHTML('<div>' + html + '</div>');

            $(raw_html).find('[id]').each(function () {
                let id = $(this).attr('id');

                if(!id || id === 'document_style'){
                    return;
                }

                counts[id] = (counts[id] || 0) + 1;
            });
        }
        catch(ex){
            console.log(ex);
        }

        let duplicates = {};

        for(let id in counts){
            if(counts[id] > 1){
                duplicates[id] = counts[id];
            }
        }

        return duplicates;
    }

    updatePageStyle(custom_class, custom_style){
        const self = this;

        let raw_html = $.parseHTML('<div>' + new FroalaEditor('div#froala-editor').html.get(true) + '</div>');

        $(raw_html).find('#document_style').remove();

        let input_hidden = '<input type="hidden" id="document_style" class="'+ custom_class +'" value="'+ custom_style +'">';
        let content = $(raw_html).html();

        content += input_hidden;

        new FroalaEditor('div#froala-editor').html.set(content);
    }

    uploadFile(file, file_name) {
        const self = this;

        let policyUrl = 'sec/developer/properties/' + self.property.id + '/documents/s3-policy-property-document';

        file["name"] = file_name;

        loading(true);
        self.SSAwsService.uploadAPIRequest(file, policyUrl, function (response) {

            if (response instanceof Error) {
                loading(false);
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.file_uri = response.config.data.key;

            self.updateDocument();
        }, file_name);
    }

    updateDocument() {
        const self = this;

        self.OTPService.getVerified(self.OTPService.TYPE_SESSION_2FA, function (data) {

            let url = 'sec/developer/properties/' + self.property.id + '/documents/' + self.document_id;

            let document = self.documents.find(x => x.id == self.document_id);

            let params = angular.copy(document);
            if (params.file_uri !== self.file_uri) {
                params.file_uri = self.file_uri;
            } else {
                self.hideModals();
                self.info_message = 'Document updated successfully';
                self.showInfoModal = true;
                $('#infoMessageModal').modal('show');
                return; // Skip
            }

            /** WEB-2469 Property Document Improvements
             * Set payment_plan_ids based on document payment_plan list **/
            let payment_plan_ids = [];
            if(document && document.payment_plan_documents && document.payment_plan_documents.length){
                $.each(document.payment_plan_documents, function(index, plan){
                    payment_plan_ids.push(plan.payment_plan_id);
                });
            }
            params.payment_plan_ids = payment_plan_ids.toString();

            loading(true);
            self.SSHttpService.putAPIRequest(url, params).then(function (response) {
                loading(false);
                if (response instanceof Error) {
                    self.SSAlertService.parseAndDisplayError(response);
                    return;
                }

                self.hideModals();
                self.info_message = 'Document updated successfully';
                self.showInfoModal = true;
                $('#infoMessageModal').modal('show');
            });
        });
    }

    renderHtml(content) {
        const self = this;

        // WEB-3597 — allow-list sanitise rich text before trusting it for ng-bind-html.
        return self.sce.trustAsHtml(window.ssSanitizeHtml(content));
    }

    onInfoMessage() {
        const self = this;

        self.hideModals();
        self.redirectBack();
    }

    redirectBack() {
        const self = this;

        if (self.IS_FLUTTER_APP) {
            self.dispatchEvents(true);
        } else {
            self.$window.location = '/developer/properties/' + self.property_id + '/documents';
        }
    }

    dispatchEvents(status) {
        try {
            window.webkit.messageHandlers.DocumentUpdatedEvent.postMessage(status);
        } catch (err) {
            console.log('Unable to post Native iOS App message.');
        }
        try {
            DocumentUpdatedEvent.postMessage(status);
        } catch (err) {
            console.log('Unable to post Native Android App message.');
        }
        try {
            var parentOrigin = document.referrer.match(/^.+:\/\/[^\/]+/)[0];
            if (!parentOrigin.match(/http[s]?:\/\/.*\.showsuite.com/)) {
                return;
            }
            window.parent.postMessage(
                {eventName: 'DocumentUpdatedEvent', status: status},
                parentOrigin
            );
            //window.parent.document.dispatchEvent(new CustomEvent('DocumentUpdatedEvent', {detail: status}));
        } catch (err) {
            console.log('Unable to dispatch Web parent document event.');
        }
        try {
            window.chrome.webview.postMessage({eventName: 'DocumentUpdatedEvent', status: status});
        } catch (err) {
            console.log('Unable to dispatch Windows App event.');
        }
    }

    hideModals() {
        const self = this;

        self.showInfoModal = false;

        if ($('#infoMessageModal').is(':visible')) $('#infoMessageModal').modal('hide');
    }

}

PropertyDocumentsEditorController.$inject = ['$scope', '$window', '$sce', 'Upload', 'SSAwsService', 'SSHttpService', 'SSUtilService', 'SSAlertService', 'SSConfigService', 'SSAppService', 'SSUserService', 'OTPService', '$timeout', 'SSConfirmationService'];
app.controller('PropertyDocumentsEditorController', PropertyDocumentsEditorController);